/* Connect Landing Page (cl-) — vanilla JS, no dependencies. */
(function () {
  'use strict';

  // ---- Header-aware smooth scroll ----
  // Detects any fixed/sticky element pinned to the top of the viewport (e.g., the theme's
  // sticky header) and offsets the scroll target so the destination isn't hidden behind it.
  function getStickyHeaderOffset() {
    // Strategy: probe a few likely header selectors first; fall back to scanning fixed elements.
    var candidates = [
      'header.site-header', 'header.shopify-section-header',
      '#header', '.header', '.site-header', '.header-wrapper',
      '.fkt-header', '.fk-header', '.minimog-header',
      'header[data-section-type]', 'header'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (!el) continue;
      var pos = window.getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var r = el.getBoundingClientRect();
      // Only count it if it's currently pinned at the top of the viewport.
      if (r.top <= 1 && r.bottom > 0) return r.height;
    }
    return 0;
  }

  function smoothScrollToTarget(target, extraOffset) {
    if (!target) return;
    var headerOffset = getStickyHeaderOffset();
    var pad = (typeof extraOffset === 'number') ? extraOffset : 12; // small breathing room
    var rect = target.getBoundingClientRect();
    var top = rect.top + window.pageYOffset - headerOffset - pad;
    if (top < 0) top = 0;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
  // Expose for any other scripts that want it (and so section-reload code can re-find it).
  window.clSmoothScrollTo = smoothScrollToTarget;

  // ---- Hero option toggle (image + price + label swap) ----
  function bindHero(root) {
    var options = root.querySelectorAll('[data-cl-option]');
    if (!options.length) return;
    if (root.__clHeroBound) return;
    root.__clHeroBound = true;
    options.forEach(function (opt) {
      opt.addEventListener('click', function () { selectOption(root, opt.getAttribute('data-cl-option')); });
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectOption(root, opt.getAttribute('data-cl-option'));
        }
      });
    });
  }
  function selectOption(root, key) {
    root.querySelectorAll('[data-cl-option]').forEach(function (b) {
      b.setAttribute('aria-selected', b.getAttribute('data-cl-option') === key ? 'true' : 'false');
    });
    root.querySelectorAll('[data-cl-hero-image]').forEach(function (img) {
      img.setAttribute('data-active', img.getAttribute('data-cl-hero-image') === key ? 'true' : 'false');
    });
    root.querySelectorAll('[data-cl-option-content]').forEach(function (el) {
      el.setAttribute('data-active', el.getAttribute('data-cl-option-content') === key ? 'true' : 'false');
    });
    var cta = root.querySelector('[data-cl-hero-cta]');
    if (cta) {
      var url = cta.getAttribute('data-cl-cta-' + key + '-url');
      if (url) cta.setAttribute('href', url);
    }
  }

  // ---- Carousel arrows (used by use-case-carousel and reviews) ----
  function bindCarousel(carousel) {
    var track = carousel.querySelector('[data-cl-carousel-track]');
    if (!track) return;
    if (carousel.__clCarouselBound) return;
    carousel.__clCarouselBound = true;
    carousel.querySelectorAll('[data-cl-carousel-arrow]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-cl-carousel-arrow');
        var card = track.querySelector('[data-cl-carousel-card]');
        var step = card ? card.getBoundingClientRect().width + 16 : 320;
        track.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
  }

  // ---- Money formatter (uses window.clMoneyFormat injected by section) ----
  function formatMoney(cents) {
    var fmt = (typeof window !== 'undefined' && window.clMoneyFormat) || '${{amount}}';
    return fmt.replace(/\{\{\s*amount(_with_comma_separator|_no_decimals_with_comma_separator|_no_decimals)?\s*\}\}/g, function (_m, mod) {
      var n = cents / 100;
      var noDec = mod === '_no_decimals' || mod === '_no_decimals_with_comma_separator';
      var comma = mod === '_with_comma_separator' || mod === '_no_decimals_with_comma_separator';
      var s = noDec ? Math.round(n).toString() : n.toFixed(2);
      if (comma) s = s.replace('.', ',');
      // basic thousands separator (rough, USD-style; comma flag inverts)
      var parts = s.split(comma ? ',' : '.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
      return parts.join(comma ? ',' : '.');
    });
  }

  // ---- Bundle Builder hero (cl-hero3) ----
  function bindBundleBuilder(root) {
    if (!root.hasAttribute('data-cl-hero-addons')) return;
    if (root.__clBundleBuilderBound) return;
    root.__clBundleBuilderBound = true;
    var stack = []; // ordered list of currently-on add-on IDs (last = newest)

    function syncState() {
      var nowOn = [];
      root.querySelectorAll('[data-cl-addon-toggle]').forEach(function (input) {
        if (input.checked) nowOn.push(input.getAttribute('data-cl-addon-id'));
      });
      stack = stack.filter(function (id) { return nowOn.indexOf(id) >= 0; });
      nowOn.forEach(function (id) { if (stack.indexOf(id) < 0) stack.push(id); });

      // total
      var primaryCents = parseInt(root.getAttribute('data-cl-primary-price') || '0', 10) || 0;
      var totalCents = primaryCents;
      root.querySelectorAll('[data-cl-addon-toggle]:checked').forEach(function (input) {
        totalCents += parseInt(input.getAttribute('data-cl-addon-price') || '0', 10) || 0;
      });
      var totalEl = root.querySelector('[data-cl-bundle-total]');
      if (totalEl) totalEl.textContent = formatMoney(totalCents);

      // image swap: last in stack, else base
      var imgKey = stack.length ? stack[stack.length - 1] : 'base';
      root.querySelectorAll('[data-cl-addon-image]').forEach(function (img) {
        img.setAttribute('data-active', img.getAttribute('data-cl-addon-image') === imgKey ? 'true' : 'false');
      });
    }

    root.querySelectorAll('[data-cl-addon-toggle]').forEach(function (input) {
      input.addEventListener('change', syncState);
    });

    var btn = root.querySelector('[data-cl-bundle-add]');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      submitBundle(root, btn);
    });

    syncState();
  }

  function showBundleError(root, msg) {
    var err = root.querySelector('[data-cl-bundle-error]');
    if (!err) return;
    err.textContent = msg;
    err.classList.add('is-visible');
    setTimeout(function () { err.classList.remove('is-visible'); }, 4000);
  }

  function submitBundle(root, btn) {
    var items = [];
    var primaryVariant = root.getAttribute('data-cl-primary-variant');
    if (primaryVariant) items.push({ id: parseInt(primaryVariant, 10), quantity: 1 });
    root.querySelectorAll('[data-cl-addon-toggle]:checked').forEach(function (input) {
      var v = input.getAttribute('data-cl-addon-variant');
      if (v) items.push({ id: parseInt(v, 10), quantity: 1 });
    });
    if (!items.length) {
      showBundleError(root, 'Please pick at least one item.');
      return;
    }
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j && j.description || 'Cart error'); });
        return r.json();
      })
      .then(function () {
        // Try to nudge a theme cart drawer; fall back to /cart navigation.
        try {
          window.dispatchEvent(new CustomEvent('cart:refresh'));
          window.dispatchEvent(new CustomEvent('cart:open'));
        } catch (_e) {}
        setTimeout(function () { window.location.href = '/cart'; }, 250);
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        showBundleError(root, (err && err.message) ? err.message : 'Could not add to cart. Try again.');
      });
  }

  // ---- Hero Builder Pro (cl-hero4): primary selector + gallery + add-ons ----
  function bindBuilderPro(root) {
    if (!root.hasAttribute('data-cl-hero4')) return;
    if (root.__clBuilderProBound) return;
    root.__clBuilderProBound = true;

    var firstPill = root.querySelector('[data-cl-primary-pill]');
    var state = {
      primaryId: firstPill ? firstPill.getAttribute('data-cl-primary-pill') : null,
      galleryIndex: 0,
      addonStack: [],
      lastInteraction: 'gallery'
    };

    root.querySelectorAll('[data-cl-primary-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var pid = pill.getAttribute('data-cl-primary-pill');
        if (pid === state.primaryId) return;
        state.primaryId = pid;
        state.galleryIndex = 0;
        state.addonStack = [];
        state.lastInteraction = 'gallery';
        root.querySelectorAll('[data-cl-addon-toggle]').forEach(function (input) { input.checked = false; });
        sync();
      });
    });

    root.querySelectorAll('[data-cl-addon-toggle]').forEach(function (input) {
      input.addEventListener('change', function () {
        var aid = input.getAttribute('data-cl-addon-id');
        if (input.checked) {
          if (state.addonStack.indexOf(aid) < 0) state.addonStack.push(aid);
          state.lastInteraction = 'addon';
        } else {
          state.addonStack = state.addonStack.filter(function (x) { return x !== aid; });
          state.lastInteraction = state.addonStack.length ? 'addon' : 'gallery';
        }
        sync();
      });
    });

    root.querySelectorAll('[data-cl-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-cl-gallery-index'), 10);
        if (isNaN(idx)) return;
        state.galleryIndex = idx;
        state.lastInteraction = 'gallery';
        sync();
      });
    });

    // Gallery navigation (arrows + swipe)
    function galleryCount() {
      return root.querySelectorAll('[data-cl-main-img^="primary:' + state.primaryId + ':"]').length;
    }
    function goPrev() {
      var c = galleryCount();
      if (c < 2) return;
      state.galleryIndex = (state.galleryIndex - 1 + c) % c;
      state.lastInteraction = 'gallery';
      sync();
    }
    function goNext() {
      var c = galleryCount();
      if (c < 2) return;
      state.galleryIndex = (state.galleryIndex + 1) % c;
      state.lastInteraction = 'gallery';
      sync();
    }
    root.querySelectorAll('[data-cl-gallery-arrow]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (a.getAttribute('data-cl-gallery-arrow') === 'prev') goPrev(); else goNext();
      });
    });

    // Swipe on the product frame
    var frame = root.querySelector('[data-cl-gallery-frame]');
    if (frame) {
      var startX = 0, startY = 0, tracking = false;
      frame.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches.length) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      frame.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        if (!e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx > 0) goPrev(); else goNext();
        }
      }, { passive: true });
    }

    var btn = root.querySelector('[data-cl-bundle-add]');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      submitBundlePro(root, btn, state);
    });

    function sync() {
      // Pills
      root.querySelectorAll('[data-cl-primary-pill]').forEach(function (p) {
        p.setAttribute('aria-selected', p.getAttribute('data-cl-primary-pill') === state.primaryId ? 'true' : 'false');
      });
      // Primary detail rows
      root.querySelectorAll('[data-cl-primary-detail]').forEach(function (d) {
        d.style.display = d.getAttribute('data-cl-primary-detail') === state.primaryId ? '' : 'none';
      });
      // Thumb sets
      root.querySelectorAll('[data-cl-thumbs-set]').forEach(function (s) {
        s.style.display = s.getAttribute('data-cl-thumbs-set') === state.primaryId ? '' : 'none';
      });
      // Active thumb
      root.querySelectorAll('[data-cl-thumb]').forEach(function (t) {
        var isActive = t.getAttribute('data-cl-primary-id') === state.primaryId &&
                       parseInt(t.getAttribute('data-cl-gallery-index'), 10) === state.galleryIndex;
        t.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      // Find current primary's slot for addon visibility
      var slot = null;
      var pill = root.querySelector('[data-cl-primary-pill="' + state.primaryId + '"]');
      if (pill) slot = pill.getAttribute('data-cl-primary-slot');

      root.querySelectorAll('[data-cl-addon-row]').forEach(function (row) {
        var compat = (row.getAttribute('data-cl-addon-compat') || '').split(',').filter(Boolean);
        var visible = !compat.length || compat.indexOf(slot) >= 0;
        row.setAttribute('data-cl-hidden', visible ? 'false' : 'true');
      });

      // Active main image
      var activeKey;
      if (state.lastInteraction === 'addon' && state.addonStack.length) {
        activeKey = 'addon:' + state.addonStack[state.addonStack.length - 1];
      } else {
        activeKey = 'primary:' + state.primaryId + ':' + state.galleryIndex;
      }
      root.querySelectorAll('[data-cl-main-img]').forEach(function (img) {
        img.setAttribute('data-active', img.getAttribute('data-cl-main-img') === activeKey ? 'true' : 'false');
      });

      // Arrow visibility (hide when current primary has < 2 images)
      var imgCount = root.querySelectorAll('[data-cl-main-img^="primary:' + state.primaryId + ':"]').length;
      root.querySelectorAll('[data-cl-gallery-arrow]').forEach(function (a) {
        if (imgCount < 2) a.setAttribute('hidden', ''); else a.removeAttribute('hidden');
      });

      // Total
      var primaryDetailEl = root.querySelector('[data-cl-primary-detail="' + state.primaryId + '"]');
      var primaryCents = primaryDetailEl ? (parseInt(primaryDetailEl.getAttribute('data-cl-primary-price') || '0', 10) || 0) : 0;
      var totalCents = primaryCents;
      root.querySelectorAll('[data-cl-addon-toggle]:checked').forEach(function (input) {
        totalCents += parseInt(input.getAttribute('data-cl-addon-price') || '0', 10) || 0;
      });
      var totalEl = root.querySelector('[data-cl-bundle-total]');
      if (totalEl) totalEl.textContent = formatMoney(totalCents);
    }

    sync();
  }

  function submitBundlePro(root, btn, state) {
    var items = [];
    var primaryDetailEl = root.querySelector('[data-cl-primary-detail="' + state.primaryId + '"]');
    if (primaryDetailEl) {
      var pVar = primaryDetailEl.getAttribute('data-cl-primary-variant');
      if (pVar) items.push({ id: parseInt(pVar, 10), quantity: 1 });
    }
    root.querySelectorAll('[data-cl-addon-toggle]:checked').forEach(function (input) {
      var v = input.getAttribute('data-cl-addon-variant');
      if (v) items.push({ id: parseInt(v, 10), quantity: 1 });
    });
    if (!items.length) {
      showBundleError(root, 'Please pick at least one item.');
      return;
    }
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j && j.description || 'Cart error'); });
        return r.json();
      })
      .then(function () {
        try {
          window.dispatchEvent(new CustomEvent('cart:refresh'));
          window.dispatchEvent(new CustomEvent('cart:open'));
        } catch (_e) {}
        setTimeout(function () { window.location.href = '/cart'; }, 250);
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        showBundleError(root, (err && err.message) ? err.message : 'Could not add to cart. Try again.');
      });
  }

  // ---- Tooltip edge-aware positioning ----
  // Measures the tooltip after it becomes visible; if it would overflow the viewport
  // (right/left/top/bottom), reposition it inline so it stays fully visible.
  function positionTooltip(host) {
    if (!host) return;
    var trust = host.querySelector('.cl-pdp__trust-tooltip');
    var iconCell = host.querySelector('.cl-pdp__icon-cell-tooltip');
    var tip = trust || iconCell;
    if (!tip) return;
    var isCentered = !!iconCell; // icon-cell tooltip uses translateX(-50%) for centering
    // Clear any prior overrides
    tip.style.left = '';
    tip.style.right = '';
    tip.style.top = '';
    tip.style.bottom = '';
    tip.style.transform = '';
    tip.style.marginTop = '';
    tip.style.marginBottom = '';
    void tip.offsetWidth; // force reflow
    var pad = 12;
    var vw = document.documentElement.clientWidth;
    var vh = document.documentElement.clientHeight;
    var r = tip.getBoundingClientRect();
    // --- Horizontal overflow ---
    if (r.right > vw - pad) {
      // Anchor right edge of tooltip to right edge of host, kill any horizontal centering.
      tip.style.left = 'auto';
      tip.style.right = '0';
      if (isCentered) tip.style.transform = 'translateX(0)';
    } else if (r.left < pad) {
      // Anchor left edge of tooltip to left edge of host.
      tip.style.left = '0';
      tip.style.right = 'auto';
      if (isCentered) tip.style.transform = 'translateX(0)';
    }
    // --- Vertical overflow ---
    if (trust && r.bottom > vh - pad) {
      // Trust tooltip is below trigger by default; flip above.
      tip.style.top = 'auto';
      tip.style.bottom = '100%';
      tip.style.marginTop = '0';
      tip.style.marginBottom = '8px';
    } else if (iconCell && r.top < pad) {
      // Icon-cell tooltip is above trigger by default; flip below.
      tip.style.bottom = 'auto';
      tip.style.top = 'calc(100% + 12px)';
    }
  }

  // ---- Generic info tooltip (hover + click; used by trust badges and icon cells) ----
  function bindInfoTip(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-cl-info-trigger]').forEach(function (btn) {
      if (btn.dataset.clInfoBound === 'true') return;
      btn.dataset.clInfoBound = 'true';
      var host = btn.closest('[data-cl-info-host]');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!host) return;
        var open = host.getAttribute('data-cl-tip-open') === 'true';
        document.querySelectorAll('[data-cl-info-host][data-cl-tip-open="true"]').forEach(function (other) {
          if (other !== host) {
            other.setAttribute('data-cl-tip-open', 'false');
            var otherBtn = other.querySelector('[data-cl-info-trigger]');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });
        var willOpen = !open;
        host.setAttribute('data-cl-tip-open', willOpen ? 'true' : 'false');
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) {
          // Wait for the visibility/transform transitions to apply, then measure.
          requestAnimationFrame(function () { positionTooltip(host); });
        }
      });
      // Hover-driven reposition so desktop hover also stays inside the viewport.
      if (host) {
        host.addEventListener('mouseenter', function () {
          requestAnimationFrame(function () { positionTooltip(host); });
        });
      }
    });
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-cl-info-host][data-cl-tip-open="true"]').forEach(function (host) {
      if (!host.contains(e.target)) {
        host.setAttribute('data-cl-tip-open', 'false');
        var btn = host.querySelector('[data-cl-info-trigger]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-cl-info-host][data-cl-tip-open="true"]').forEach(function (host) {
      host.setAttribute('data-cl-tip-open', 'false');
      var btn = host.querySelector('[data-cl-info-trigger]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  });

  // ---- Floating Shop Now FAB (cl-fab) ----
  function bindFab(root) {
    if (!root.hasAttribute('data-cl-fab')) return;
    if (root.__clFabBound) return;
    root.__clFabBound = true;

    var hideAttr = root.getAttribute('data-cl-fab-hide-when') || '';
    var hideSelectors = hideAttr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var hideTargets = [];
    hideSelectors.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) { hideTargets.push(el); });
      } catch (_e) {}
    });

    var atcEnabled = root.getAttribute('data-cl-fab-atc-enabled') === 'true';
    var href = root.getAttribute('href') || '';
    var pdpEl = null;
    if (href.charAt(0) === '#' && href.length > 1) {
      try { pdpEl = document.querySelector(href); } catch (_e) {}
    }
    var shopAria = root.getAttribute('data-cl-fab-aria-shop') || 'Shop now';
    var atcAria = root.getAttribute('data-cl-fab-aria-atc') || 'Add to cart';

    if (!hideTargets.length || !('IntersectionObserver' in window)) {
      root.setAttribute('data-cl-visible', 'true');
    } else {
      var visState = new WeakMap();
      function updateVisibility() {
        var anyVisible = false;
        hideTargets.forEach(function (el) {
          if (visState.get(el)) anyVisible = true;
        });
        root.setAttribute('data-cl-visible', anyVisible ? 'false' : 'true');
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visState.set(entry.target, entry.isIntersecting && entry.intersectionRatio > 0.05);
        });
        updateVisibility();
      }, { threshold: [0, 0.05, 0.5, 1] });
      hideTargets.forEach(function (el) { observer.observe(el); });
    }

    function updateMode() {
      var mode = 'shop';
      if (atcEnabled && pdpEl) {
        var rect = pdpEl.getBoundingClientRect();
        // PDP fully above viewport = scrolled past it → ATC mode
        if (rect.bottom < 0) mode = 'atc';
      }
      if (root.getAttribute('data-cl-fab-mode') !== mode) {
        root.setAttribute('data-cl-fab-mode', mode);
        root.setAttribute('aria-label', mode === 'atc' ? atcAria : shopAria);
      }
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          updateMode();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', updateMode, { passive: true });
    updateMode();

    root.addEventListener('click', function (e) {
      e.preventDefault();
      var mode = root.getAttribute('data-cl-fab-mode') || 'shop';

      if (mode === 'atc') {
        var pdpAtc = document.querySelector('[data-cl-pdp-add]');
        if (pdpAtc && !pdpAtc.disabled && pdpAtc.getAttribute('aria-disabled') !== 'true') {
          pdpAtc.click();
        } else if (window.console && window.console.warn) {
          window.console.warn('[cl-fab] ATC mode active but PDP ATC button is missing or disabled');
        }
        return;
      }

      // Shop mode → smooth scroll to PDP (header-aware)
      if (href.charAt(0) === '#' && href.length > 1) {
        var target;
        try { target = document.querySelector(href); } catch (_e) { target = null; }
        if (target) {
          smoothScrollToTarget(target);
        } else if (window.console && window.console.warn) {
          window.console.warn('[cl-fab] target not found:', href + ' — check the PDP section\'s anchor ID');
        }
      }
    });
  }

  // ---- Product Hero pin-scroll (opt-in via section setting) ----
  // Same architecture as the hotspots pin-scroll — JS-driven position:fixed via state attr,
  // not position:sticky (which is fragile inside the theme editor iframe). Added pin-active
  // class after verifying viewport is tall enough to make pinning useful.
  function bindHeroPinScroll(root) {
    if (root.getAttribute('data-cl-phero-pin-scroll') !== 'true') return;
    if (root.__clPheroPinBound) return;
    root.__clPheroPinBound = true;

    var bgImg = root.querySelector('.cl-phero__bg-img');
    var raf = 0;

    function refreshActiveState() {
      // Only activate if viewport has enough room to make the pin worthwhile
      var canPin = window.innerHeight >= 480;
      if (canPin) root.classList.add('cl-phero--pin-active');
      else {
        root.classList.remove('cl-phero--pin-active');
        root.removeAttribute('data-cl-phero-pin-state');
        root.style.removeProperty('--cl-phero-bg-pan-y');
      }
      return canPin;
    }

    function update() {
      raf = 0;
      if (!refreshActiveState()) return;
      var sectionRect = root.getBoundingClientRect();
      var vh = window.innerHeight;
      var pinHeight = vh; // pin wrapper is 100vh
      var totalScroll = root.offsetHeight - pinHeight;
      if (totalScroll <= 0) {
        root.setAttribute('data-cl-phero-pin-state', 'before');
        root.style.removeProperty('--cl-phero-bg-pan-y');
        return;
      }
      var newState;
      if (sectionRect.top > 0) newState = 'before';
      else if (sectionRect.top <= 0 && sectionRect.bottom >= pinHeight) newState = 'active';
      else newState = 'after';
      if (root.getAttribute('data-cl-phero-pin-state') !== newState) {
        root.setAttribute('data-cl-phero-pin-state', newState);
      }

      // BG pan: progress 0 → 1 maps to object-position-y 0 → bg_pan_max
      var progress = -sectionRect.top / totalScroll;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      var maxPanRaw = parseFloat(getComputedStyle(root).getPropertyValue('--cl-phero-bg-pan-max'));
      var maxPan = isNaN(maxPanRaw) ? 30 : maxPanRaw;
      // Center around 50%: at progress 0, pan-y = 50 - maxPan/2; at progress 1, pan-y = 50 + maxPan/2
      var panY = 50 - (maxPan / 2) + (maxPan * progress);
      root.style.setProperty('--cl-phero-bg-pan-y', panY);
    }
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (bgImg && !bgImg.complete) bgImg.addEventListener('load', update);
    update();
  }

  // ---- Product Hero (cl-phero) — smooth-scroll on Shop Now CTA + auto-center active pill ----
  function bindProductHero(root) {
    if (!root.hasAttribute('data-cl-phero')) return;
    if (root.__clProductHeroBound) return;
    root.__clProductHeroBound = true;
    bindHeroPinScroll(root);
    root.querySelectorAll('[data-cl-phero-cta]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) === '#' && href.length > 1) {
          e.preventDefault();
          var target;
          try { target = document.querySelector(href); } catch (_e) { target = null; }
          if (target) {
            smoothScrollToTarget(target);
          } else if (window.console && window.console.warn) {
            window.console.warn('[cl-phero] CTA target not found:', href + ' — check the PDP section\'s anchor ID');
          }
        }
      });
    });

    // Auto-center the active configuration pill in its scrollable strip
    // Targets the inner pills strip (overflow-x: auto), not the outer pill container.
    var configsContainer = root.querySelector('.cl-phero__configs-pills');
    if (configsContainer) {
      var activePill = configsContainer.querySelector('[data-cl-active="true"]');
      if (activePill) {
        var centerActivePill = function () {
          var pillRect = activePill.getBoundingClientRect();
          var containerRect = configsContainer.getBoundingClientRect();
          var pillCenter = pillRect.left + pillRect.width / 2;
          var containerCenter = containerRect.left + containerRect.width / 2;
          configsContainer.scrollLeft += (pillCenter - containerCenter);
        };
        setTimeout(centerActivePill, 60);
        // Re-center on viewport resize (covers rotation + responsive shifts)
        window.addEventListener('resize', function () {
          if (root.__clPheroResizeRaf) cancelAnimationFrame(root.__clPheroResizeRaf);
          root.__clPheroResizeRaf = requestAnimationFrame(centerActivePill);
        });
      }
    }
  }

  // ---- Product PDP (cl-pdp) — gallery + read-more + addons + multi-item ATC ----
  function bindProductPdp(root) {
    if (!root.hasAttribute('data-cl-pdp')) return;
    // Idempotence: bindProductPdp may be called multiple times (init + section:load + any
    // re-render). Without this guard, the ATC + sticky-ATC + bundle click listeners get
    // attached N times — clicking ATC then fires submitToCart() N times, multi-adding to
    // cart (and the N-th call may rate-limit and surface a brief "Could not add" error).
    if (root.__clPdpBound) return;
    root.__clPdpBound = true;

    // OLD comparison guide modal removed in Project 7 Stage 7.B. The Project 3
    // comparison drawer (bindComparisonDrawer, cl-comp-drawer-*) replaces it.
    var guideModal = null;

    // ---- Add-on "More details" modals — ONE PER ADDON (reverted from shared-modal experiment) ----
    function openAddonModal(addonId) {
      var modal = root.querySelector('[data-cl-pdp-addon-modal="' + addonId + '"]');
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeAddonModals() {
      root.querySelectorAll('[data-cl-pdp-addon-modal]').forEach(function (m) {
        if (m.getAttribute('aria-hidden') === 'false') m.setAttribute('aria-hidden', 'true');
      });
      // Release body scroll only if NO modal anywhere is open (addon, bundle, or guide)
      if (!root.querySelector('[data-cl-pdp-addon-modal][aria-hidden="false"]') &&
          !root.querySelector('[data-cl-pdp-bundle-modal][aria-hidden="false"]') &&
          (!guideModal || guideModal.getAttribute('aria-hidden') !== 'false')) {
        document.body.style.overflow = '';
      }
    }
    root.querySelectorAll('[data-cl-pdp-addon-modal-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        openAddonModal(b.getAttribute('data-cl-pdp-addon-modal-open'));
      });
    });
    root.querySelectorAll('[data-cl-pdp-addon-modal-close]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); closeAddonModals(); });
    });
    // Per-addon-modal gallery thumb clicks
    root.querySelectorAll('[data-cl-pdp-addon-modal]').forEach(function (modal) {
      modal.querySelectorAll('[data-cl-addon-modal-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-cl-addon-modal-thumb');
          modal.querySelectorAll('[data-cl-addon-modal-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t.getAttribute('data-cl-addon-modal-thumb') === idx ? 'true' : 'false');
          });
          modal.querySelectorAll('[data-cl-addon-modal-img]').forEach(function (img) {
            img.setAttribute('data-active', img.getAttribute('data-cl-addon-modal-img') === idx ? 'true' : 'false');
          });
        });
      });
    });

    // ---- Per-bundle "More details" modals — ONE PER BUNDLE (Project 7 Stage 7.A) ----
    // Mirrors the per-addon modal pattern above. Replaces the prior shared
    // scrolling modal so post-click UX matches Add-Ons.
    function openBundleModal(bundleId) {
      var modal = root.querySelector('[data-cl-pdp-bundle-modal="' + bundleId + '"]');
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeBundleModals() {
      root.querySelectorAll('[data-cl-pdp-bundle-modal]').forEach(function (m) {
        if (m.getAttribute('aria-hidden') === 'false') m.setAttribute('aria-hidden', 'true');
      });
      if (!root.querySelector('[data-cl-pdp-bundle-modal][aria-hidden="false"]') &&
          !root.querySelector('[data-cl-pdp-addon-modal][aria-hidden="false"]') &&
          (!guideModal || guideModal.getAttribute('aria-hidden') !== 'false')) {
        document.body.style.overflow = '';
      }
    }
    root.querySelectorAll('[data-cl-pdp-bundle-modal-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        openBundleModal(b.getAttribute('data-cl-pdp-bundle-modal-open'));
      });
    });
    // ---- Pre-order split-bar: right-tile click toggles panel ----
    root.querySelectorAll('[data-cl-pdp-preorder-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var container = btn.closest('[data-cl-pdp-preorder]');
        if (!container) return;
        var isOpen = container.getAttribute('data-open') === 'true';
        container.setAttribute('data-open', isOpen ? 'false' : 'true');
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
    root.querySelectorAll('[data-cl-pdp-bundle-modal-close]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); closeBundleModals(); });
    });
    // ESC closes whichever modal is open (addon-modal or bundle-modal)
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (root.querySelector('[data-cl-pdp-addon-modal][aria-hidden="false"]')) closeAddonModals();
      if (root.querySelector('[data-cl-pdp-bundle-modal][aria-hidden="false"]')) closeBundleModals();
    });
    // Per-bundle-modal gallery thumb clicks (mirror of addon-modal thumb logic)
    root.querySelectorAll('[data-cl-pdp-bundle-modal]').forEach(function (modal) {
      modal.querySelectorAll('[data-cl-bundle-modal-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-cl-bundle-modal-thumb');
          modal.querySelectorAll('[data-cl-bundle-modal-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t.getAttribute('data-cl-bundle-modal-thumb') === idx ? 'true' : 'false');
          });
          modal.querySelectorAll('[data-cl-bundle-modal-img]').forEach(function (img) {
            img.setAttribute('data-active', img.getAttribute('data-cl-bundle-modal-img') === idx ? 'true' : 'false');
          });
        });
      });
    });

    // ---- Addon modal "Add to Cart" buttons — mirror the row's toggle ----
    function getAddonCheckbox(addonId) {
      var li = root.querySelector('[data-cl-addon-id="' + addonId + '"]');
      return li ? li.querySelector('[data-cl-pdp-addon]') : null;
    }
    function syncAddonCartButton(addonId) {
      var btn = root.querySelector('[data-cl-pdp-addon-modal-cart="' + addonId + '"]');
      var cb = getAddonCheckbox(addonId);
      if (!btn || !cb) return;
      if (cb.checked) btn.setAttribute('data-cl-cart-state', 'added');
      else btn.removeAttribute('data-cl-cart-state');
    }
    root.querySelectorAll('[data-cl-pdp-addon-modal-cart]').forEach(function (btn) {
      var addonId = btn.getAttribute('data-cl-pdp-addon-modal-cart');
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        var cb = getAddonCheckbox(addonId);
        if (!cb || cb.disabled) return;
        cb.checked = !cb.checked;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
        syncAddonCartButton(addonId);
        // Close on add (let the user keep shopping); leave open on remove (in case of misclick)
        if (cb.checked) closeAddonModals();
      });
      syncAddonCartButton(addonId);
    });
    root.querySelectorAll('[data-cl-pdp-addon]').forEach(function (cb) {
      var li = cb.closest('[data-cl-addon-id]');
      if (!li) return;
      var addonId = li.getAttribute('data-cl-addon-id');
      cb.addEventListener('change', function () { syncAddonCartButton(addonId); });
    });

    var galleryIndex = 0;
    var thumbs = root.querySelectorAll('[data-cl-pdp-thumb]');
    var mainImages = root.querySelectorAll('[data-cl-pdp-main-img]');

    function setGalleryIndex(idx) {
      galleryIndex = idx;
      thumbs.forEach(function (t) {
        var on = parseInt(t.getAttribute('data-cl-pdp-thumb'), 10) === idx;
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      mainImages.forEach(function (img) {
        var on = parseInt(img.getAttribute('data-cl-pdp-main-img'), 10) === idx;
        img.setAttribute('data-active', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = parseInt(t.getAttribute('data-cl-pdp-thumb'), 10);
        if (!isNaN(idx)) setGalleryIndex(idx);
      });
    });

    function goPrev() {
      var c = mainImages.length;
      if (c < 2) return;
      setGalleryIndex((galleryIndex - 1 + c) % c);
    }
    function goNext() {
      var c = mainImages.length;
      if (c < 2) return;
      setGalleryIndex((galleryIndex + 1) % c);
    }
    root.querySelectorAll('[data-cl-pdp-arrow]').forEach(function (a) {
      a.addEventListener('click', function () {
        if (a.getAttribute('data-cl-pdp-arrow') === 'prev') goPrev();
        else goNext();
      });
      if (mainImages.length < 2) a.setAttribute('hidden', '');
    });

    var frame = root.querySelector('[data-cl-pdp-frame]');
    if (frame) {
      var startX = 0, startY = 0, tracking = false;
      frame.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches.length) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      frame.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        if (!e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx > 0) goPrev(); else goNext();
        }
      }, { passive: true });
    }

    if (mainImages.length > 0) setGalleryIndex(0);

    function getQty() {
      var qInput = root.querySelector('[data-cl-pdp-qty-input]');
      if (!qInput) return 1;
      var n = parseInt(qInput.value, 10);
      if (!n || n < 1) n = 1;
      return n;
    }
    function syncTotal() {
      // Re-read primary price each call so variant picker changes are reflected.
      var primaryPriceCents = parseInt(root.getAttribute('data-cl-primary-price') || '0', 10) || 0;
      var qty = getQty();
      var totalCents = primaryPriceCents * qty;
      root.querySelectorAll('[data-cl-pdp-addon]:checked').forEach(function (input) {
        totalCents += parseInt(input.getAttribute('data-cl-addon-price') || '0', 10) || 0;
      });
      var totalEl = root.querySelector('[data-cl-pdp-total]');
      if (totalEl) totalEl.textContent = formatMoney(totalCents);
      // Sticky bar price mirrors the unit price (NOT total), so users see a per-unit anchor.
      var stickyPriceEl = root.querySelector('[data-cl-pdp-sticky-price]');
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(primaryPriceCents);
    }
    root.__clPdpSyncTotal = syncTotal;
    root.querySelectorAll('[data-cl-pdp-addon]').forEach(function (input) {
      input.addEventListener('change', syncTotal);
    });
    syncTotal();

    // Add-ons list scroll hint (show "Scroll for more" + bottom fade when overflowing)
    var addonsList = root.querySelector('[data-cl-pdp-addons-list]');
    var addonsWrap = root.querySelector('[data-cl-pdp-addons-wrap]');
    var addonsHint = root.querySelector('[data-cl-pdp-addons-hint]');
    function updateAddonsScroll() {
      if (!addonsList) return;
      var canScroll = addonsList.scrollHeight - addonsList.clientHeight > 4;
      var atBottom = addonsList.scrollTop + addonsList.clientHeight >= addonsList.scrollHeight - 4;
      var showHint = canScroll && !atBottom;
      if (addonsHint) {
        if (showHint) addonsHint.removeAttribute('hidden');
        else addonsHint.setAttribute('hidden', '');
      }
      if (addonsWrap) addonsWrap.style.setProperty('--cl-pdp-fade-bottom', showHint ? '1' : '0');
    }
    if (addonsList) {
      addonsList.addEventListener('scroll', updateAddonsScroll);
      window.addEventListener('resize', updateAddonsScroll);
      setTimeout(updateAddonsScroll, 60);
    }

    function submitToCart(qtyOverride) {
      var btn = root.querySelector('[data-cl-pdp-add]');
      var stickyBtn = root.querySelector('[data-cl-pdp-sticky-add]');
      var items = [];
      var primaryVariant = root.getAttribute('data-cl-primary-variant');
      var qty = (typeof qtyOverride === 'number' && qtyOverride > 0) ? qtyOverride : getQty();
      if (primaryVariant) items.push({ id: parseInt(primaryVariant, 10), quantity: qty });
      root.querySelectorAll('[data-cl-pdp-addon]:checked').forEach(function (input) {
        var v = input.getAttribute('data-cl-addon-variant');
        if (v) items.push({ id: parseInt(v, 10), quantity: 1 });
      });
      if (!items.length) {
        showPdpError(root, 'Please pick at least one item.');
        return;
      }
      if (btn) btn.setAttribute('aria-busy', 'true');
      if (stickyBtn) stickyBtn.setAttribute('aria-busy', 'true');
      // Read action mode from the button (preorder section only emits this);
      // missing attribute = existing behavior (add then redirect to /cart),
      // which keeps the original PDP section's ATC fully backward-compatible.
      var ctaAction = (btn && btn.getAttribute('data-cl-pdp-action')) || 'add_and_view_cart';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j && j.description || 'Cart error'); });
          return r.json();
        })
        .then(function () {
          try {
            window.dispatchEvent(new CustomEvent('cart:refresh'));
            window.dispatchEvent(new CustomEvent('cart:open'));
          } catch (_e) {}
          if (ctaAction === 'add_and_stay') {
            if (btn) btn.removeAttribute('aria-busy');
            if (stickyBtn) stickyBtn.removeAttribute('aria-busy');
            return;
          }
          if (ctaAction === 'buy_now') {
            setTimeout(function () { window.location.href = '/checkout'; }, 250);
            return;
          }
          // Default 'add_and_view_cart' — open theme cart drawer; fall back to /cart redirect if drawer machinery unavailable
          if (window.MinimogTheme && window.MinimogTheme.Cart && window.MinimogTheme.Cart.openCartDrawer) {
            if (btn) btn.removeAttribute('aria-busy');
            if (stickyBtn) stickyBtn.removeAttribute('aria-busy');
            Promise.resolve(window.MinimogTheme.Cart.refreshCart && window.MinimogTheme.Cart.refreshCart())
              .then(function () { window.MinimogTheme.Cart.openCartDrawer(); });
          } else {
            setTimeout(function () { window.location.href = '/cart'; }, 250);
          }
        })
        .catch(function (err) {
          if (btn) btn.removeAttribute('aria-busy');
          if (stickyBtn) stickyBtn.removeAttribute('aria-busy');
          showPdpError(root, (err && err.message) ? err.message : 'Could not add to cart.');
        });
    }
    root.__clPdpSubmit = submitToCart;

    // ---- Bundle "Add to Cart" buttons (section view + modal) ----
    // Each Bundle block has a Linked Product picker. The button carries that
    // product's first-available variant id in data-cl-bundle-variant. Clicking
    // the button adds that single variant to cart and redirects to /cart.
    // No add-on toggling, no key resolution, no primary-product side effects —
    // the bundle is just a linked product.
    // Helper: open the theme cart drawer (or fall back to /cart redirect)
    function openCartDrawer() {
      try {
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        window.dispatchEvent(new CustomEvent('cart:open'));
      } catch (_e) {}
      if (window.MinimogTheme && window.MinimogTheme.Cart && window.MinimogTheme.Cart.openCartDrawer) {
        Promise.resolve(window.MinimogTheme.Cart.refreshCart && window.MinimogTheme.Cart.refreshCart())
          .then(function () { window.MinimogTheme.Cart.openCartDrawer(); });
      } else {
        window.location.href = '/cart';
      }
    }
    // Bundle ATC — two-state button:
    //   1st tap (default state): add to cart via AJAX, close modal if applicable,
    //     transition the button (both card + modal copies) to "added" state.
    //     Does NOT open the cart drawer (per Squires's bundle UX direction —
    //     customers may want to keep browsing bundles/add-ons before checkout).
    //   2nd tap (added state): opens the cart drawer.
    // Note: this is a separate handler from the main product ATC (data-cl-pdp-add),
    // so it doesn't affect the site-wide "open cart drawer after add" behavior.
    root.querySelectorAll('[data-cl-pdp-bundle-add], [data-cl-pdp-bundle-modal-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.hasAttribute('aria-busy')) return;
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        // Second-tap path: button already in "added" state → open cart drawer
        if (btn.getAttribute('data-cl-bundle-state') === 'added') {
          openCartDrawer();
          return;
        }
        var variantId = btn.getAttribute('data-cl-bundle-variant');
        if (!variantId) {
          showPdpError(root, 'This bundle has no linked product yet.');
          return;
        }
        btn.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j && j.description || 'Cart error'); });
            return r.json();
          })
          .then(function () {
            try { window.dispatchEvent(new CustomEvent('cart:refresh')); } catch (_e) {}
            // Close modal if this was the modal ATC button
            if (btn.hasAttribute('data-cl-pdp-bundle-modal-add')) {
              var modalEl = btn.closest('[data-cl-pdp-bundle-modal]');
              if (modalEl) {
                modalEl.setAttribute('aria-hidden', 'true');
                document.body.style.overflow = '';
              }
            }
            // Mark BOTH the card + modal buttons for this bundle as "added"
            var bundleId = btn.getAttribute('data-cl-pdp-bundle-modal-add') || btn.getAttribute('data-cl-pdp-bundle-add');
            var twinSelector = bundleId
              ? '[data-cl-pdp-bundle-add="' + bundleId + '"], [data-cl-pdp-bundle-modal-add="' + bundleId + '"]'
              : null;
            var twins = twinSelector ? root.querySelectorAll(twinSelector) : [btn];
            twins.forEach(function (b) {
              b.removeAttribute('aria-busy');
              b.setAttribute('data-cl-bundle-state', 'added');
              b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>Added';
              b.setAttribute('aria-label', 'Added — tap to view cart');
            });
          })
          .catch(function (err) {
            btn.removeAttribute('aria-busy');
            showPdpError(root, (err && err.message) ? err.message : 'Could not add bundle to cart.');
          });
      });
    });

    var btn = root.querySelector('[data-cl-pdp-add]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        submitToCart();
      });
    }
    var stickyBtn = root.querySelector('[data-cl-pdp-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        submitToCart();
      });
    }
  }

  function showPdpError(root, msg) {
    var err = root.querySelector('[data-cl-pdp-error]');
    if (!err) return;
    err.textContent = msg;
    err.classList.add('is-visible');
    setTimeout(function () { err.classList.remove('is-visible'); }, 4000);
  }

  // ---- Photo zoom lightbox (preorder PDP section only) ----
  // Click any [data-cl-pdp-zoom-trigger] in the PDP root opens a fullscreen
  // viewer. Transform-based zoom (1x → maxScale), pan when zoomed, swipe
  // between photos when not zoomed, keyboard nav. Pointer events handle both
  // mouse and touch in a single code path. Self-contained — does not depend
  // on the other PDP state.
  function bindPdpPhotoLightbox(lightbox) {
    if (!lightbox || lightbox.__clBound) return;
    lightbox.__clBound = true;
    var photos = [];
    try { photos = JSON.parse(lightbox.getAttribute('data-cl-pdp-photo-lightbox-photos') || '[]'); }
    catch (e) { photos = []; }
    if (!photos.length) return;
    var maxScale = parseFloat(lightbox.getAttribute('data-cl-pdp-photo-lightbox-max-scale') || '4') || 4;
    var minScale = 1;
    var sectionRoot = lightbox.closest('[data-cl-pdp]') || lightbox.parentElement;
    var triggers = sectionRoot.querySelectorAll('[data-cl-pdp-zoom-trigger]');
    var stage = lightbox.querySelector('[data-cl-pdp-photo-lightbox-stage]');
    var imgEl = lightbox.querySelector('[data-cl-pdp-photo-lightbox-img]');
    var prevBtn = lightbox.querySelector('[data-cl-pdp-photo-lightbox-arrow="prev"]');
    var nextBtn = lightbox.querySelector('[data-cl-pdp-photo-lightbox-arrow="next"]');
    var closeBtns = lightbox.querySelectorAll('[data-cl-pdp-photo-lightbox-close]');
    var curEl = lightbox.querySelector('[data-cl-pdp-photo-lightbox-current]');
    var totalEl = lightbox.querySelector('[data-cl-pdp-photo-lightbox-total]');
    var counterWrap = lightbox.querySelector('[data-cl-pdp-photo-lightbox-counter]');
    if (totalEl) totalEl.textContent = String(photos.length);
    // Video entries (2026-09-22): the lightbox list mirrors the album, so a product
    // video is reachable by swiping/arrowing through the zoom viewer. Entries look
    // like {type:'video', src, poster} or {type:'embed', url, poster}; plain photos
    // have no `type` and behave exactly as before.
    var videoEl = null, embedEl = null;
    function isMedia(i) { var p = photos[i]; return !!(p && (p.type === 'video' || p.type === 'embed')); }
    function getVideoEl() {
      if (!videoEl && stage) {
        videoEl = document.createElement('video');
        videoEl.className = 'cl-pdp__photo-lightbox-video';
        videoEl.setAttribute('controls', '');
        videoEl.setAttribute('playsinline', '');
        videoEl.setAttribute('loop', '');
        videoEl.muted = true;
        videoEl.setAttribute('preload', 'none');
        videoEl.hidden = true;
        stage.appendChild(videoEl);
      }
      return videoEl;
    }
    function getEmbedEl() {
      if (!embedEl && stage) {
        embedEl = document.createElement('iframe');
        embedEl.className = 'cl-pdp__photo-lightbox-embed';
        embedEl.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        embedEl.setAttribute('allowfullscreen', '');
        embedEl.setAttribute('title', 'Product video');
        embedEl.hidden = true;
        stage.appendChild(embedEl);
      }
      return embedEl;
    }
    function stopMedia() {
      if (videoEl) { try { videoEl.pause(); } catch (_e) {} videoEl.hidden = true; }
      if (embedEl) { embedEl.hidden = true; if (embedEl.src) embedEl.removeAttribute('src'); }
    }
    if (photos.length < 2) {
      if (prevBtn) prevBtn.setAttribute('hidden', '');
      if (nextBtn) nextBtn.setAttribute('hidden', '');
      if (counterWrap) counterWrap.setAttribute('hidden', '');
    }
    var state = {
      index: 0, scale: 1, translateX: 0, translateY: 0,
      pointers: new Map(),
      pinchStartDistance: 0, pinchStartScale: 1, pinchMidpoint: { x: 0, y: 0 },
      panStartX: 0, panStartY: 0, panStartTx: 0, panStartTy: 0,
      swipeStartX: 0, swipeStartY: 0, swipeStartTime: 0,
      isPanning: false, isPinching: false, isSwiping: false
    };
    function applyTransform() {
      if (!imgEl) return;
      imgEl.style.transform = 'translate(' + state.translateX + 'px, ' + state.translateY + 'px) scale(' + state.scale + ')';
      imgEl.setAttribute('data-zoomed', state.scale > 1.01 ? 'true' : 'false');
    }
    function resetTransform() {
      state.scale = 1; state.translateX = 0; state.translateY = 0;
      applyTransform();
    }
    function setImage(idx) {
      if (idx < 0) idx = photos.length - 1;
      if (idx >= photos.length) idx = 0;
      state.index = idx;
      var p = photos[idx];
      if (!imgEl) return;
      if (curEl) curEl.textContent = String(idx + 1);
      resetTransform();
      stopMedia();
      if (p.type === 'video') {
        imgEl.hidden = true;
        var v = getVideoEl();
        if (v) {
          if (v.getAttribute('src') !== p.src) v.setAttribute('src', p.src);
          if (p.poster) v.setAttribute('poster', p.poster);
          v.hidden = false;
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        }
        return;
      }
      if (p.type === 'embed') {
        imgEl.hidden = true;
        var f = getEmbedEl();
        if (f) { f.src = p.url; f.hidden = false; }
        return;
      }
      imgEl.hidden = false;
      // Swap immediately and recenter. The prior version faded out, waited 160ms,
      // then faded back in — that delay read as lag on every photo change. Motion
      // feedback now comes from the live swipe-drag + the CSS transform transition.
      imgEl.src = p.src; imgEl.alt = p.alt || '';
    }
    function openAt(idx) {
      setImage(idx);
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      stopMedia();
      lightbox.setAttribute('aria-hidden', 'true');
      var anyOpen = document.querySelector('[data-cl-pdp-modal][aria-hidden="false"], [data-cl-pdp-addon-modal][aria-hidden="false"], [data-cl-pdp-photo-lightbox][aria-hidden="false"]');
      if (!anyOpen) document.body.style.overflow = '';
    }
    function prev() { setImage(state.index - 1); }
    function next() { setImage(state.index + 1); }
    function zoomToward(newScale, originX, originY) {
      if (isMedia(state.index)) return;
      newScale = Math.max(minScale, Math.min(maxScale, newScale));
      if (newScale === state.scale) return;
      var ratio = newScale / state.scale;
      state.translateX = originX - (originX - state.translateX) * ratio;
      state.translateY = originY - (originY - state.translateY) * ratio;
      state.scale = newScale;
      applyTransform();
    }
    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = parseInt(t.getAttribute('data-cl-pdp-zoom-trigger'), 10) || 0;
        openAt(idx);
      });
    });
    closeBtns.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); next(); });
    document.addEventListener('keydown', function (e) {
      if (lightbox.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      else if (e.key === '0') { e.preventDefault(); resetTransform(); }
    });
    if (imgEl) {
      imgEl.addEventListener('dblclick', function (e) {
        if (isMedia(state.index)) return;
        e.preventDefault();
        var rect = stage.getBoundingClientRect();
        var x = e.clientX - rect.left, y = e.clientY - rect.top;
        if (state.scale > 1.01) { resetTransform(); }
        else { zoomToward(2, x, y); }
      });
    }
    if (stage) {
      var lastWheelNav = 0;
      stage.addEventListener('wheel', function (e) {
        if (lightbox.getAttribute('aria-hidden') !== 'false') return;
        e.preventDefault();
        // Horizontal trackpad swipe navigates; vertical scroll zooms. Previously a
        // sideways swipe (deltaY≈0) fell into the zoom-out branch, so scrolling
        // left/right shrank the image instead of changing photos.
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          var nowW = Date.now();
          if (Math.abs(e.deltaX) > 8 && nowW - lastWheelNav > 350) {
            lastWheelNav = nowW;
            if (e.deltaX > 0) next(); else prev();
          }
          return;
        }
        if (Math.abs(e.deltaY) < 1) return;
        var rect = stage.getBoundingClientRect();
        var x = e.clientX - rect.left, y = e.clientY - rect.top;
        var factor = e.deltaY < 0 ? 1.12 : 1 / 1.12;
        zoomToward(state.scale * factor, x, y);
      }, { passive: false });

      function pdist(a, b) { var dx = a.x - b.x, dy = a.y - b.y; return Math.sqrt(dx * dx + dy * dy); }
      function pmid(a, b, rect) { return { x: (a.x + b.x) / 2 - rect.left, y: (a.y + b.y) / 2 - rect.top }; }

      stage.addEventListener('pointerdown', function (e) {
        if (lightbox.getAttribute('aria-hidden') !== 'false') return;
        // On a video slide, taps in the control strip belong to the player, not to
        // the swipe/pan gesture handler.
        if (isMedia(state.index)) {
          var mEl = (videoEl && !videoEl.hidden) ? videoEl : (embedEl && !embedEl.hidden ? embedEl : null);
          if (mEl) {
            var mr = mEl.getBoundingClientRect();
            var inMedia = e.clientX >= mr.left && e.clientX <= mr.right && e.clientY >= mr.top && e.clientY <= mr.bottom;
            if (inMedia && (mEl === embedEl || e.clientY > mr.bottom - 64)) return;
          }
        }
        try { stage.setPointerCapture(e.pointerId); } catch (_e) {}
        state.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (imgEl) imgEl.setAttribute('data-gesturing', 'true');
        if (state.pointers.size === 1) {
          var p = state.pointers.values().next().value;
          if (state.scale > 1.01) {
            state.isPanning = true;
            state.panStartX = p.x; state.panStartY = p.y;
            state.panStartTx = state.translateX; state.panStartTy = state.translateY;
            if (imgEl) imgEl.setAttribute('data-panning', 'true');
          } else {
            state.isSwiping = true;
            state.swipeStartX = p.x; state.swipeStartY = p.y;
            state.swipeStartTime = Date.now();
          }
        } else if (state.pointers.size === 2) {
          state.isPanning = false; state.isSwiping = false; state.isPinching = true;
          var pts = Array.from(state.pointers.values());
          state.pinchStartDistance = pdist(pts[0], pts[1]) || 1;
          state.pinchStartScale = state.scale;
          state.pinchMidpoint = pmid(pts[0], pts[1], stage.getBoundingClientRect());
        }
      });

      stage.addEventListener('pointermove', function (e) {
        if (!state.pointers.has(e.pointerId)) return;
        state.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (state.isPinching && state.pointers.size === 2) {
          var pts = Array.from(state.pointers.values());
          var d = pdist(pts[0], pts[1]);
          var newScale = state.pinchStartScale * (d / state.pinchStartDistance);
          zoomToward(newScale, state.pinchMidpoint.x, state.pinchMidpoint.y);
        } else if (state.isPanning && state.pointers.size === 1) {
          var p = state.pointers.values().next().value;
          state.translateX = state.panStartTx + (p.x - state.panStartX);
          state.translateY = state.panStartTy + (p.y - state.panStartY);
          applyTransform();
        } else if (state.isSwiping && state.pointers.size === 1 && !isMedia(state.index)) {
          // Live drag-follow when not zoomed: the photo tracks the finger so the
          // swipe feels responsive instead of an all-or-nothing jump on release.
          var sp = state.pointers.values().next().value;
          state.translateX = sp.x - state.swipeStartX;
          state.translateY = 0;
          applyTransform();
        }
      });

      function endPointer(e) {
        if (!state.pointers.has(e.pointerId)) return;
        state.pointers.delete(e.pointerId);
        if (state.isSwiping && state.pointers.size === 0) {
          var dx = e.clientX - state.swipeStartX;
          var dy = e.clientY - state.swipeStartY;
          var dt = Date.now() - state.swipeStartTime;
          var stageW = (stage.getBoundingClientRect().width) || 1;
          var velocity = Math.abs(dx) / Math.max(dt, 1); // px per ms
          // Navigate on a deliberate drag (>18% of the frame) OR a quick flick
          // (velocity), as long as it's mostly horizontal. The old dt<900 + 30px
          // gate ignored slow swipes — the "needs a really good swipe" problem.
          var passed = Math.abs(dx) > Math.abs(dy) && (Math.abs(dx) > stageW * 0.18 || velocity > 0.5);
          state.isSwiping = false;
          if (passed) {
            // Swap + recenter instantly while the transition is still suppressed
            // (data-gesturing is removed just below), so it feels immediate.
            if (dx < 0) next(); else prev();
          } else if (imgEl) {
            // Didn't cross the threshold — animate the photo back to center.
            imgEl.removeAttribute('data-gesturing');
            state.translateX = 0; state.translateY = 0; applyTransform();
          }
        }
        if (state.pointers.size < 2) state.isPinching = false;
        if (state.pointers.size === 0) {
          state.isPanning = false;
          if (imgEl) {
            imgEl.removeAttribute('data-panning');
            imgEl.removeAttribute('data-gesturing');
          }
        }
      }
      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);
    }
  }

  // ---- Standalone product PDP — variant picker, qty, sticky, delivery ----
  function bindPdpProductExtras(root) {
    if (!root.hasAttribute('data-cl-pdp-product')) return;
    if (root.__clPdpProductBound) return;
    root.__clPdpProductBound = true;

    // Variant data
    var dataEl = root.querySelector('[data-cl-pdp-variant-data]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent.trim()); } catch (e) { variants = []; }
    }

    var variantIdInput = root.querySelector('[data-cl-pdp-variant-id]');
    var optionInputs = root.querySelectorAll('[data-cl-pdp-option-input]');
    var priceEl = root.querySelector('[data-cl-pdp-price]');
    var compareEl = root.querySelector('[data-cl-pdp-compare]');
    var saveEl = root.querySelector('[data-cl-pdp-save]');
    var skuEl = root.querySelector('[data-cl-pdp-sku]');
    var skuValueEl = root.querySelector('[data-cl-pdp-sku-value]');
    var atcBtn = root.querySelector('[data-cl-pdp-add]');
    var atcText = root.querySelector('[data-cl-pdp-atc-text]');
    var stockMsg = root.querySelector('[data-cl-pdp-stock-msg]');
    var stockText = root.querySelector('[data-cl-pdp-stock-text]');
    var swapImage = root.getAttribute('data-cl-swap-on-variant') === 'true';
    var urgencyTpl = (root.querySelector('[name="urgency_text_hidden"]') || {}).value || '';

    function getSelectedOptions() {
      var selected = [];
      optionInputs.forEach(function (input) {
        if (input.checked) {
          var idx = parseInt(input.getAttribute('data-cl-pdp-option-idx'), 10);
          selected[idx] = input.value;
        }
      });
      return selected;
    }

    function findVariant(selected) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          if (v.options[j] !== selected[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function formatMoneyCents(cents) {
      // Reuse the global formatMoney helper from the main IIFE scope.
      return formatMoney(cents);
    }

    function updateOptionLabels(selected) {
      root.querySelectorAll('[data-cl-pdp-opt-current]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-cl-pdp-opt-current'), 10);
        if (!isNaN(idx) && selected[idx] != null) el.textContent = selected[idx];
      });
    }

    function applyVariant(v) {
      if (!v) {
        // No matching variant — disable ATC.
        if (atcBtn) {
          atcBtn.setAttribute('disabled', '');
          atcBtn.setAttribute('aria-disabled', 'true');
        }
        if (atcText) atcText.textContent = (atcText.getAttribute('data-cl-unavail') || 'UNAVAILABLE');
        return;
      }
      // Hidden ID input + root attrs
      if (variantIdInput) variantIdInput.value = v.id;
      root.setAttribute('data-cl-primary-variant', String(v.id));
      root.setAttribute('data-cl-primary-price', String(v.price));

      // Price + compare
      if (priceEl) priceEl.textContent = formatMoneyCents(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoneyCents(v.compare_at_price);
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }
      if (saveEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.removeAttribute('hidden');
        } else {
          saveEl.setAttribute('hidden', '');
        }
      }

      // SKU
      if (skuEl) {
        if (v.sku) {
          if (skuValueEl) skuValueEl.textContent = v.sku;
          skuEl.removeAttribute('hidden');
        } else {
          skuEl.setAttribute('hidden', '');
        }
      }

      // ATC label + state
      if (atcBtn && atcText) {
        if (v.available) {
          atcBtn.removeAttribute('disabled');
          atcBtn.removeAttribute('aria-disabled');
          var label = atcText.getAttribute('data-cl-avail') || atcText.textContent || 'ADD TO CART';
          // We don't store the labels separately on the element — rely on cached defaults on first run.
        } else {
          atcBtn.setAttribute('disabled', '');
          atcBtn.setAttribute('aria-disabled', 'true');
        }
      }

      // Stock urgency
      if (stockMsg && stockText) {
        var threshold = parseInt(root.getAttribute('data-cl-urgency-threshold') || '0', 10) || 0;
        var qty = v.inventory_quantity;
        var tracked = v.inventory_management === 'shopify';
        if (
          v.available &&
          tracked &&
          threshold > 0 &&
          typeof qty === 'number' &&
          qty > 0 &&
          qty <= threshold
        ) {
          var tpl = root.getAttribute('data-cl-urgency-text') || 'Only {qty} left in stock — order soon!';
          stockText.textContent = tpl.replace('{qty}', qty);
          stockMsg.removeAttribute('hidden');
        } else {
          stockMsg.setAttribute('hidden', '');
        }
      }

      // Swap main image to variant featured image
      if (swapImage && v.featured_image && v.featured_image.id) {
        var match = root.querySelector('[data-cl-pdp-image-id="' + v.featured_image.id + '"]');
        if (match) {
          var idx = parseInt(match.getAttribute('data-cl-pdp-main-img'), 10);
          var thumbs = root.querySelectorAll('[data-cl-pdp-thumb]');
          var mains = root.querySelectorAll('[data-cl-pdp-main-img]');
          thumbs.forEach(function (t) {
            t.setAttribute('aria-current', parseInt(t.getAttribute('data-cl-pdp-thumb'), 10) === idx ? 'true' : 'false');
          });
          mains.forEach(function (img) {
            img.setAttribute('data-active', parseInt(img.getAttribute('data-cl-pdp-main-img'), 10) === idx ? 'true' : 'false');
          });
        }
      }

      // Recompute total
      if (typeof root.__clPdpSyncTotal === 'function') root.__clPdpSyncTotal();

      // Update URL with ?variant=ID without reloading
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', String(v.id));
        history.replaceState({}, '', u.toString());
      } catch (e) {}
    }

    // Cache the original ATC labels so we can flip between available / sold-out / unavailable.
    if (atcText && !atcText.getAttribute('data-cl-avail')) {
      atcText.setAttribute('data-cl-avail', atcText.textContent.trim());
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var sel = getSelectedOptions();
        updateOptionLabels(sel);
        applyVariant(findVariant(sel));
      });
    });

    // Initial sync (in case Shopify pre-selected a variant via ?variant=)
    var initialSel = getSelectedOptions();
    updateOptionLabels(initialSel);
    var initial = findVariant(initialSel);
    if (initial) applyVariant(initial);

    // ---- Quantity +/- ----
    root.querySelectorAll('[data-cl-pdp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = root.querySelector('[data-cl-pdp-qty-input]');
        if (!input) return;
        var v = parseInt(input.value, 10) || 1;
        if (b.getAttribute('data-cl-pdp-qty') === 'plus') v = v + 1;
        else v = Math.max(1, v - 1);
        input.value = v;
        if (typeof root.__clPdpSyncTotal === 'function') root.__clPdpSyncTotal();
      });
    });
    var qInput = root.querySelector('[data-cl-pdp-qty-input]');
    if (qInput) {
      qInput.addEventListener('input', function () {
        if (typeof root.__clPdpSyncTotal === 'function') root.__clPdpSyncTotal();
      });
      qInput.addEventListener('blur', function () {
        var v = parseInt(qInput.value, 10);
        if (!v || v < 1) qInput.value = 1;
      });
    }

    // ---- Sticky mobile ATC visibility ----
    var stickyBar = root.querySelector('[data-cl-pdp-sticky]');
    if (stickyBar && atcBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // Show sticky when main ATC is NOT visible.
          if (e.isIntersecting) {
            stickyBar.setAttribute('aria-hidden', 'true');
          } else {
            stickyBar.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0.05 });
      io.observe(atcBtn);
    }

  }

  // ---- Feed Collage (cl-fc) — tabbed Instagram-style modal feed ----
  function bindFeedCollage(root) {
    if (!root.hasAttribute('data-cl-fc')) return;
    if (root.__clFeedCollageBound) return;
    root.__clFeedCollageBound = true;

    var inlineTabs = root.querySelectorAll('[data-cl-fc-tab]');
    var modalTabs = root.querySelectorAll('[data-cl-fc-modal-tab]');
    var modal = root.querySelector('[data-cl-fc-modal]');
    var feeds = root.querySelectorAll('[data-cl-fc-feed]');
    var feedsContainer = root.querySelector('[data-cl-fc-feeds]');
    var tabsContainer = root.querySelector('[data-cl-fc-tabs]');
    var arrowPrev = root.querySelector('[data-cl-fc-tabs-arrow="prev"]');
    var arrowNext = root.querySelector('[data-cl-fc-tabs-arrow="next"]');
    var modalTabsContainer = root.querySelector('[data-cl-fc-modal-tabs]');

    var videoObserver = null;

    function setActiveTab(tabId) {
      inlineTabs.forEach(function (t) {
        t.setAttribute('aria-selected', t.getAttribute('data-cl-fc-tab') === tabId ? 'true' : 'false');
      });
      modalTabs.forEach(function (t) {
        var on = t.getAttribute('data-cl-fc-modal-tab') === tabId;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && modalTabsContainer) {
          // Ensure the active modal tab is in view in the strip
          var rect = t.getBoundingClientRect();
          var crect = modalTabsContainer.getBoundingClientRect();
          if (rect.left < crect.left || rect.right > crect.right) {
            t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
          }
        }
      });
      feeds.forEach(function (f) {
        f.setAttribute('data-cl-active', f.getAttribute('data-cl-fc-feed') === tabId ? 'true' : 'false');
      });
      if (feedsContainer) feedsContainer.scrollTop = 0;
    }

    function openModal(tabId) {
      if (!modal) return;
      setActiveTab(tabId);
      modal.setAttribute('data-cl-open', 'true');
      document.body.style.overflow = 'hidden';
      attachVideoObserver();
    }

    function closeModal() {
      if (!modal) return;
      modal.setAttribute('data-cl-open', 'false');
      document.body.style.overflow = '';
      detachVideoObserver();
    }

    function attachVideoObserver() {
      if (!('IntersectionObserver' in window) || !feedsContainer) return;
      detachVideoObserver();
      var videos = modal.querySelectorAll('[data-cl-fc-video]');
      videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            entry.target.play().catch(function () {});
          } else {
            entry.target.pause();
          }
        });
      }, { root: feedsContainer, threshold: [0.4, 0.7] });
      videos.forEach(function (v) { videoObserver.observe(v); });
    }

    function detachVideoObserver() {
      if (videoObserver) {
        videoObserver.disconnect();
        videoObserver = null;
      }
      if (modal) {
        modal.querySelectorAll('[data-cl-fc-video]').forEach(function (v) { v.pause(); });
      }
    }

    inlineTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        openModal(tab.getAttribute('data-cl-fc-tab'));
      });
    });
    modalTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveTab(tab.getAttribute('data-cl-fc-modal-tab'));
        attachVideoObserver();
      });
    });
    root.querySelectorAll('[data-cl-fc-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.getAttribute('data-cl-open') === 'true') {
        closeModal();
      }
    });

    if (tabsContainer && arrowPrev && arrowNext) {
      function scrollTabs(dir) {
        var step = tabsContainer.getBoundingClientRect().width * 0.7;
        tabsContainer.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
      }
      arrowPrev.addEventListener('click', function () { scrollTabs('prev'); });
      arrowNext.addEventListener('click', function () { scrollTabs('next'); });

      function updateArrows() {
        var max = tabsContainer.scrollWidth - tabsContainer.clientWidth - 4;
        if (max <= 0) {
          arrowPrev.setAttribute('hidden', '');
          arrowNext.setAttribute('hidden', '');
          return;
        }
        if (tabsContainer.scrollLeft <= 4) arrowPrev.setAttribute('hidden', ''); else arrowPrev.removeAttribute('hidden');
        if (tabsContainer.scrollLeft >= max) arrowNext.setAttribute('hidden', ''); else arrowNext.removeAttribute('hidden');
      }
      tabsContainer.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      // Run after layout settles
      setTimeout(updateArrows, 50);
    }
  }

  // ---- Photo Gallery (cl-gal) ----
  function bindGallery(root) {
    if (!root.hasAttribute('data-cl-gal')) return;
    if (root.__clGalleryBound) return;
    root.__clGalleryBound = true;

    var rail = root.querySelector('[data-cl-gal-rail]');
    var categories = root.querySelectorAll('[data-cl-gal-category]');
    var lightbox = root.querySelector('[data-cl-gal-lightbox]');
    var lightboxImg = root.querySelector('[data-cl-gal-lightbox-img]');

    if (categories[0]) categories[0].setAttribute('data-cl-active', 'true');

    if (rail && 'IntersectionObserver' in window && categories.length) {
      var observer = new IntersectionObserver(function (entries) {
        var bestEntry = null;
        var bestRatio = 0;
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > bestRatio) {
            bestRatio = entry.intersectionRatio;
            bestEntry = entry.target;
          }
        });
        if (bestEntry && bestRatio > 0.5) {
          categories.forEach(function (c) { c.removeAttribute('data-cl-active'); });
          bestEntry.setAttribute('data-cl-active', 'true');
        }
      }, { root: rail, threshold: [0.4, 0.6, 0.8, 1.0] });
      categories.forEach(function (c) { observer.observe(c); });
    }

    function openLightbox(src, alt) {
      if (!lightbox || !lightboxImg) return;
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.setAttribute('data-cl-open', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.setAttribute('data-cl-open', 'false');
      if (lightboxImg) {
        lightboxImg.src = '';
        lightboxImg.alt = '';
      }
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-cl-gal-photo]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-cl-gal-photo');
        var alt = btn.getAttribute('data-cl-gal-photo-alt') || '';
        if (src) openLightbox(src, alt);
      });
    });

    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || (e.target.closest && e.target.closest('[data-cl-gal-lightbox-close]'))) {
          closeLightbox();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox && lightbox.getAttribute('data-cl-open') === 'true') {
        closeLightbox();
      }
    });
  }

  // ---- Hotspots image (cl-hs) ----
  function bindHotspots(root) {
    if (!root.hasAttribute('data-cl-hs')) return;
    var imageWrap = root.querySelector('[data-cl-hs-image-wrap]');
    if (!imageWrap) return;
    if (root.__clHotspotsBound) return;
    root.__clHotspotsBound = true;

    function show(id) {
      var hotspot = root.querySelector('[data-cl-hotspot="' + id + '"]');
      if (!hotspot) return;
      var x = hotspot.style.left || '50%';
      var y = hotspot.style.top || '50%';
      imageWrap.style.setProperty('--cl-hs-origin', x + ' ' + y);
      // Set x/y separately so the detail card can position itself relative
      // to the hotspot's coordinates (desktop only — mobile centers regardless).
      imageWrap.style.setProperty('--cl-hs-origin-x', x);
      imageWrap.style.setProperty('--cl-hs-origin-y', y);
      // Quadrant anchor: card goes into the OPPOSITE quadrant of the hotspot
      // so it doesn't cover the dot. Top-half → card below; bottom-half → above.
      var xNum = parseFloat(x) || 50;
      var yNum = parseFloat(y) || 50;
      var vert = yNum < 50 ? 'below' : 'above';
      var horiz = xNum < 50 ? 'right' : 'left';
      imageWrap.setAttribute('data-cl-hs-card-anchor', vert + '-' + horiz);
      imageWrap.setAttribute('data-cl-zoomed', 'true');
      root.querySelectorAll('[data-cl-hs-card]').forEach(function (c) {
        c.setAttribute('data-cl-active', c.getAttribute('data-cl-hs-card') === id ? 'true' : 'false');
      });
      // Scroll lock: prevent background page from scrolling while card is open.
      // Same pattern as the PDP modals. Always lock — hide() restores it.
      document.body.style.overflow = 'hidden';
    }

    function hide() {
      imageWrap.removeAttribute('data-cl-zoomed');
      root.querySelectorAll('[data-cl-hs-card]').forEach(function (c) {
        c.setAttribute('data-cl-active', 'false');
      });
      // Release scroll lock — but only if no other modal is still open.
      var anyOpen = document.querySelector('[data-cl-pdp-modal][aria-hidden="false"], [data-cl-pdp-addon-modal][aria-hidden="false"], [data-cl-pdp-photo-lightbox][aria-hidden="false"]');
      if (!anyOpen) document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-cl-hotspot]').forEach(function (h) {
      h.addEventListener('click', function (e) {
        e.preventDefault();
        show(h.getAttribute('data-cl-hotspot'));
      });
    });
    root.querySelectorAll('[data-cl-hs-toc]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        show(t.getAttribute('data-cl-hs-toc'));
      });
    });
    root.querySelectorAll('[data-cl-hs-close]').forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        hide();
      });
    });
    var backdrop = root.querySelector('[data-cl-hs-backdrop]');
    if (backdrop) backdrop.addEventListener('click', hide);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && imageWrap.getAttribute('data-cl-zoomed') === 'true') {
        hide();
      }
    });
  }

  // ---- Quick add (single-product AJAX add to cart, used by recos cards) ----
  function bindQuickAdd(form) {
    if (form.dataset.clQuickAddBound === 'true') return;
    form.dataset.clQuickAddBound = 'true';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j && j.description || 'Cart error'); });
          return r.json();
        })
        .then(function () {
          try {
            window.dispatchEvent(new CustomEvent('cart:refresh'));
            window.dispatchEvent(new CustomEvent('cart:open'));
          } catch (_e) {}
          setTimeout(function () { window.location.href = '/cart'; }, 250);
        })
        .catch(function (err) {
          if (btn) btn.removeAttribute('aria-busy');
          var msg = (err && err.message) ? err.message : 'Could not add to cart.';
          var feedback = form.querySelector('[data-cl-quick-add-error]');
          if (feedback) {
            feedback.textContent = msg;
            feedback.classList.add('is-visible');
            setTimeout(function () { feedback.classList.remove('is-visible'); }, 4000);
          } else {
            alert(msg);
          }
        });
    });
  }

  // ---- Video section ----
  function bindVideo(root) {
    if (!root.hasAttribute('data-cl-vid')) return;
    if (root.__clVidBound) return;
    root.__clVidBound = true;

    var openBtns = root.querySelectorAll('[data-cl-vid-open]');
    var modal = root.querySelector('[data-cl-vid-modal]');
    if (!modal) return;
    var closeBtns = modal.querySelectorAll('[data-cl-vid-close]');
    var frame = modal.querySelector('[data-cl-vid-frame]');
    var embedUrl = frame ? frame.getAttribute('data-cl-vid-embed') : '';
    var isIframe = frame && frame.getAttribute('data-cl-vid-iframe') === 'true';
    // Shopify-hosted video ships as a <template> so nothing loads until opened.
    var hostedTpl = modal.querySelector('template[data-cl-vid-template]');

    function open() {
      if (!frame || (!embedUrl && !hostedTpl)) return;
      // Inject the player only when opened so YouTube doesn't autoplay on page load.
      if (!frame.firstElementChild) {
        if (hostedTpl) {
          frame.appendChild(hostedTpl.content.cloneNode(true));
          var hv = frame.querySelector('video');
          if (hv) {
            hv.muted = false; // play with sound — the user tapped Play
            var p = hv.play();
            if (p && p.catch) {
              // If the browser still blocks unmuted playback, start muted
              // instead of silently failing.
              p.catch(function () { hv.muted = true; hv.play().catch(function () {}); });
            }
          }
        } else if (isIframe) {
          var iframe = document.createElement('iframe');
          iframe.src = embedUrl;
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', 'Video');
          frame.appendChild(iframe);
        } else {
          var video = document.createElement('video');
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          var src = document.createElement('source');
          src.src = embedUrl;
          video.appendChild(src);
          frame.appendChild(video);
        }
      }
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Stop playback by removing the player; recreated on next open.
      if (frame) frame.innerHTML = '';
    }
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });
  }

  // ---- FAQ ----
  // Stop words excluded from search matching.
  var FAQ_STOP_WORDS = ['the','a','an','and','or','but','of','to','in','on','at','by','for','with','from','as','is','are','was','were','be','been','being','it','this','that','these','those','i','you','he','she','we','they','my','your','his','her','our','their','what','which','who','whom','do','does','did','can','could','should','would','will','have','has','had','if','then','than','so','not','no','yes','about','into','out','up','down','over','under','again','more','most','some','any','all','one','two','three','only','just'];

  function faqTokenize(str) {
    if (!str) return [];
    var raw = String(str).toLowerCase().replace(/[^\w\s]+/g, ' ').split(/\s+/);
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var w = raw[i];
      if (!w) continue;
      if (w.length < 2) continue;
      if (FAQ_STOP_WORDS.indexOf(w) !== -1) continue;
      out.push(w);
    }
    return out;
  }

  function bindFaq(root) {
    if (!root.hasAttribute('data-cl-faq')) return;
    if (root.__clFaqBound) return;
    root.__clFaqBound = true;

    var cats = root.querySelectorAll('[data-cl-faq-cat]');
    var items = root.querySelectorAll('[data-cl-faq-item]');
    var emptyMsg = root.querySelector('[data-cl-faq-empty]');
    var form = root.querySelector('[data-cl-faq-search-form]');
    var input = root.querySelector('[data-cl-faq-search-input]');
    var webhook = root.getAttribute('data-cl-faq-webhook') || '';

    var activeCat = cats.length ? cats[0].getAttribute('data-cl-faq-cat') : '';
    var searchTerms = [];

    function applyFilter() {
      var visibleCount = 0;
      items.forEach(function (el) {
        var itemCats = (el.getAttribute('data-cl-faq-cats') || '').split(',').map(function (s) { return s.trim(); });
        var matchCat = !activeCat || itemCats.indexOf(activeCat) !== -1;
        var matchSearch = true;
        if (searchTerms.length) {
          var hay = el.getAttribute('data-cl-faq-text') || '';
          for (var i = 0; i < searchTerms.length; i++) {
            if (hay.indexOf(searchTerms[i]) === -1) { matchSearch = false; break; }
          }
        }
        var show = matchCat && matchSearch;
        if (show) {
          el.removeAttribute('hidden');
          visibleCount++;
        } else {
          el.setAttribute('hidden', '');
          el.removeAttribute('open');
        }
      });
      if (emptyMsg) {
        if (visibleCount === 0) emptyMsg.removeAttribute('hidden');
        else emptyMsg.setAttribute('hidden', '');
      }
      return visibleCount;
    }

    cats.forEach(function (c) {
      c.addEventListener('click', function () {
        cats.forEach(function (cc) {
          cc.removeAttribute('data-cl-active');
          cc.setAttribute('aria-selected', 'false');
        });
        c.setAttribute('data-cl-active', 'true');
        c.setAttribute('aria-selected', 'true');
        activeCat = c.getAttribute('data-cl-faq-cat');
        applyFilter();
      });
    });

    function trackSearch(query, count) {
      var payload = {
        query: query,
        results: count,
        no_results: count === 0,
        section_id: root.getAttribute('data-cl-section-id') || '',
        page: location.pathname,
        ts: new Date().toISOString()
      };
      // GA4 / GTM
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'cl_faq_search', faq_search: payload });
      } catch (err) {}
      // Custom event for any pixel/listener
      try {
        document.dispatchEvent(new CustomEvent('cl-faq-search', { detail: payload }));
      } catch (err) {}
      // Optional webhook
      if (webhook) {
        try {
          fetch(webhook, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true,
            mode: 'no-cors'
          }).catch(function () {});
        } catch (err) {}
      }
    }

    if (form && input) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var raw = (input.value || '').trim();
        searchTerms = faqTokenize(raw);
        var count = applyFilter();
        if (raw) trackSearch(raw, count);
      });
      input.addEventListener('input', function () {
        // Live filter while typing (without firing a tracking event on each keystroke).
        var raw = (input.value || '').trim();
        searchTerms = faqTokenize(raw);
        applyFilter();
      });
    }

    applyFilter();
  }

  // ---- Mechanism 3-step (photo) tap-to-zoom ----
  function bindMspStep(step) {
    if (step.__clMspBound) return;
    step.__clMspBound = true;
    step.addEventListener('click', function () {
      var active = step.getAttribute('data-cl-msp-active') === 'true';
      // Close others in the same section so only one is "active"
      var section = step.closest('section');
      if (section) {
        section.querySelectorAll('[data-cl-msp-step]').forEach(function (s) {
          s.removeAttribute('data-cl-msp-active');
        });
      }
      if (!active) step.setAttribute('data-cl-msp-active', 'true');
    });
  }

  // ---- Bridge description: word-level truncation that preserves inline HTML ----
  // Walks the DOM of the description, slices the HTML at the Nth word while keeping inline
  // formatting (strong/em/u/a/span/etc.) intact. Renders the toggle inline at the end of
  // whatever content is currently visible (preview ends with "Continue reading", expanded
  // ends with "Show less" — both at the end of the last line of visible text).
  function bindBridgeDesc(root) {
    if (root.__clBridgeDescBound) return;
    root.__clBridgeDescBound = true;
    var textEl = root.querySelector('[data-cl-bridge-desc-text]');
    if (!textEl) return;
    var maxWords = parseInt(root.getAttribute('data-cl-max-words'), 10) || 18;
    var expandLabel = root.getAttribute('data-cl-expand-label') || 'Continue reading';
    var collapseLabel = root.getAttribute('data-cl-collapse-label') || 'Show less';

    var fullHtml = textEl.innerHTML;
    // Count words in the full text (HTML stripped only for counting)
    var temp = document.createElement('div');
    temp.innerHTML = fullHtml;
    var totalWords = (temp.textContent.match(/\S+/g) || []).length;

    if (totalWords <= maxWords) {
      // Not enough text to truncate — render full HTML, no toggle.
      return;
    }

    // Build truncated preview HTML by walking the DOM and clipping at maxWords
    function truncateHtmlByWords(html, n) {
      var src = document.createElement('div');
      src.innerHTML = html;
      var dst = document.createElement('div');
      var remaining = n;

      function clone(node, parent) {
        if (remaining <= 0) return false;
        if (node.nodeType === 3 /* text */) {
          var raw = node.nodeValue;
          var words = raw.match(/\s*\S+\s*|\s+$/g) || [];
          if (!words.length) {
            parent.appendChild(document.createTextNode(raw));
            return true;
          }
          var taken = words.slice(0, remaining);
          remaining -= taken.length;
          parent.appendChild(document.createTextNode(taken.join('')));
          return remaining > 0;
        }
        if (node.nodeType === 1 /* element */) {
          var copy = node.cloneNode(false);
          parent.appendChild(copy);
          var children = Array.from(node.childNodes);
          for (var i = 0; i < children.length; i++) {
            var keepGoing = clone(children[i], copy);
            if (!keepGoing) return false;
          }
          return remaining > 0;
        }
        return true;
      }

      var roots = Array.from(src.childNodes);
      for (var i = 0; i < roots.length; i++) {
        if (remaining <= 0) break;
        clone(roots[i], dst);
      }
      return dst.innerHTML;
    }

    var previewHtml = truncateHtmlByWords(fullHtml, maxWords);

    function toggleMarkup(state) {
      var label = state === 'collapsed' ? expandLabel : collapseLabel;
      var iconPath = state === 'collapsed'
        ? '<polyline points="6 9 12 15 18 9"/>' // chevron-down (continue — reads as "more below")
        : '<polyline points="18 15 12 9 6 15"/>'; // chevron-up (collapse)
      return '<button type="button" class="cl-bridge__desc-toggle" data-cl-bridge-desc-toggle data-cl-target="' + state + '">' +
        '<span class="cl-bridge__desc-toggle-text">' + label + '</span>' +
        '<svg class="cl-bridge__desc-toggle-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + iconPath + '</svg>' +
        '</button>';
    }

    // Inject the toggle INSIDE the last block-level element of the HTML (the last <p>, <li>,
    // <blockquote>, etc.) so it flows inline with the final line of text instead of dropping
    // to a new line below the paragraph. If no block element is found, append at root.
    function injectToggle(html, toggleHtml) {
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      var blocks = wrap.querySelectorAll('p, li, blockquote, h1, h2, h3, h4, h5, h6, div');
      var target = blocks.length > 0 ? blocks[blocks.length - 1] : wrap;
      target.insertAdjacentHTML('beforeend', toggleHtml);
      return wrap.innerHTML;
    }

    function render(state) {
      if (state === 'collapsed') {
        // Preview HTML + ellipsis + Continue reading toggle, all inside the last <p>
        var trailingHtml = '<span class="cl-bridge__desc-ellipsis">…</span> ' + toggleMarkup('collapsed');
        textEl.innerHTML = injectToggle(previewHtml, trailingHtml);
      } else {
        // Full HTML + Show less toggle inside the last <p>
        textEl.innerHTML = injectToggle(fullHtml, ' ' + toggleMarkup('expanded'));
      }
      root.setAttribute('data-cl-state', state);
    }

    // Initial render based on data-cl-state set by Liquid
    var initialState = root.getAttribute('data-cl-state') || 'collapsed';
    render(initialState === 'expanded' ? 'expanded' : 'collapsed');

    // Click handler — re-render on each toggle click. We use event delegation so the click
    // continues working after we replace innerHTML.
    textEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cl-bridge-desc-toggle]');
      if (!btn) return;
      e.preventDefault();
      var target = btn.getAttribute('data-cl-target');
      // target tells us what state we're CURRENTLY in; flip it
      render(target === 'collapsed' ? 'expanded' : 'collapsed');
    });
  }

  // ---- Bridge glossary modal (open/close) ----
  function bindBridgeGlossary(root) {
    if (root.__clBridgeGlossaryBound) return;
    root.__clBridgeGlossaryBound = true;
    var modal = root.querySelector('[data-cl-bridge-glossary-modal]');
    if (!modal) return;
    var openBtns = root.querySelectorAll('[data-cl-bridge-glossary-open]');
    var closeBtns = modal.querySelectorAll('[data-cl-bridge-glossary-close]');
    function open() {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });
  }

  // ---- System Equation v3: linked-pair carousels + product-card reveal ----
  // Replaces the morning's modal pattern. Each [data-cl-eq-section] hosts two
  // carousels (attachments + system) whose centered index is kept in sync.
  // The currently-centered system card's inner product layer also reveals to
  // a corner when the card scrolls into view past the trigger threshold.
  function bindSystemEquation(root) {
    if (root.__clEqV3Bound) return;
    root.__clEqV3Bound = true;

    var carouselA = root.querySelector('[data-cl-eq-carousel="attachments"]');
    var carouselS = root.querySelector('[data-cl-eq-carousel="system"]');
    if (!carouselA || !carouselS) return;

    var debounceMs = parseInt(root.getAttribute('data-sync-debounce-ms') || '100', 10);
    var tapEnabled = root.getAttribute('data-tap-to-center') !== 'false';
    var arrowEnabled = root.getAttribute('data-arrow-nav') !== 'false';
    var defaultIdx = parseInt(root.getAttribute('data-default-idx') || '0', 10);
    var revealEnabled = root.getAttribute('data-reveal-enabled') !== 'false';
    var revealThreshold = parseInt(root.getAttribute('data-reveal-threshold') || '60', 10);

    var isProgrammaticScroll = false;

    function itemsOf(carousel) { return Array.prototype.slice.call(carousel.querySelectorAll('[data-cl-eq-item]')); }

    function getCenteredIndex(carousel) {
      var rect = carousel.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var nearest = 0, nearestDist = Infinity;
      itemsOf(carousel).forEach(function (item, i) {
        var r = item.getBoundingClientRect();
        var itemCenter = r.left + r.width / 2;
        var d = Math.abs(itemCenter - center);
        if (d < nearestDist) { nearestDist = d; nearest = i; }
      });
      return nearest;
    }

    function updateCenteredClasses() {
      var ai = getCenteredIndex(carouselA);
      var si = getCenteredIndex(carouselS);
      itemsOf(carouselA).forEach(function (it, i) { it.classList.toggle('is-centered', i === ai); });
      itemsOf(carouselS).forEach(function (it, i) { it.classList.toggle('is-centered', i === si); });
      // Reveal should only ever apply to the currently centered system card.
      // Clear .is-revealed on any other product-layer; the IntersectionObserver
      // will re-add it on the centered one when the vertical position warrants.
      itemsOf(carouselS).forEach(function (it, i) {
        if (i !== si) {
          var pl = it.querySelector('.cl-eq__product-layer');
          if (pl) pl.classList.remove('is-revealed');
        }
      });
    }

    function scrollCarouselToIndex(carousel, idx, behavior) {
      var item = itemsOf(carousel)[idx];
      if (!item) return;
      var carouselRect = carousel.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var targetScroll = carousel.scrollLeft + (itemRect.left + itemRect.width / 2) - (carouselRect.left + carouselRect.width / 2);
      carousel.scrollTo({ left: targetScroll, behavior: behavior || 'smooth' });
    }

    function centerOnIndex(idx, behavior) {
      isProgrammaticScroll = true;
      scrollCarouselToIndex(carouselA, idx, behavior);
      scrollCarouselToIndex(carouselS, idx, behavior);
      setTimeout(function () {
        isProgrammaticScroll = false;
        updateCenteredClasses();
      }, behavior === 'auto' || behavior === 'instant' ? 50 : 500);
    }

    function makeSyncHandler(source, target) {
      var timer = null;
      return function () {
        if (isProgrammaticScroll) return;
        updateCenteredClasses();
        clearTimeout(timer);
        timer = setTimeout(function () {
          var idx = getCenteredIndex(source);
          var tIdx = getCenteredIndex(target);
          if (idx !== tIdx) {
            isProgrammaticScroll = true;
            scrollCarouselToIndex(target, idx);
            setTimeout(function () { isProgrammaticScroll = false; updateCenteredClasses(); }, 400);
          }
        }, debounceMs);
      };
    }

    carouselA.addEventListener('scroll', makeSyncHandler(carouselA, carouselS), { passive: true });
    carouselS.addEventListener('scroll', makeSyncHandler(carouselS, carouselA), { passive: true });

    if (tapEnabled) {
      function bindTaps(carousel) {
        itemsOf(carousel).forEach(function (item, i) {
          item.addEventListener('click', function (e) {
            // Don't hijack clicks on the CTA link or the arrows.
            if (e.target.closest('.cl-eq__cta') || e.target.closest('.cl-eq__arrow')) return;
            centerOnIndex(i);
          });
        });
      }
      bindTaps(carouselA);
      bindTaps(carouselS);
    }

    if (arrowEnabled) {
      root.querySelectorAll('[data-cl-eq-arrow]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var target = btn.getAttribute('data-cl-eq-arrow-target');
          var carousel = target === 'attachments' ? carouselA : carouselS;
          var dir = btn.getAttribute('data-cl-eq-arrow') === 'left' ? -1 : 1;
          var cur = getCenteredIndex(carousel);
          var len = itemsOf(carousel).length;
          centerOnIndex(Math.max(0, Math.min(len - 1, cur + dir)));
        });
      });
    }

    // ---- Product-card reveal-on-scroll ----
    // Honors prefers-reduced-motion at CSS layer (transition: none rule there).
    // Here we just gate the JS observation on the same media query so we
    // don't toggle classes on reduced-motion users.
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (revealEnabled && !prefersReduced && 'IntersectionObserver' in window) {
      function evaluateReveal() {
        var si = getCenteredIndex(carouselS);
        var centered = itemsOf(carouselS)[si];
        if (!centered) return;
        var card = centered.querySelector('.cl-eq__system-card');
        var product = centered.querySelector('.cl-eq__product-layer');
        if (!card || !product) return;
        // Trigger when card's vertical center is above the configured % of viewport height.
        var rect = card.getBoundingClientRect();
        var cardCenterY = rect.top + rect.height / 2;
        var triggerLine = (window.innerHeight || document.documentElement.clientHeight) * (revealThreshold / 100);
        // Card center is BELOW triggerLine (i.e. cardCenterY > triggerLine) = before reveal threshold,
        // ABOVE triggerLine (cardCenterY < triggerLine) = scrolled past, reveal.
        if (cardCenterY < triggerLine) {
          product.classList.add('is-revealed');
        } else {
          product.classList.remove('is-revealed');
        }
      }
      // Cheap rAF throttle on scroll.
      var rafId = null;
      function onScrollOrResize() {
        if (rafId !== null) return;
        rafId = window.requestAnimationFrame(function () {
          rafId = null;
          evaluateReveal();
        });
      }
      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize, { passive: true });
      // Also re-evaluate when the centered system card changes.
      carouselA.addEventListener('scroll', onScrollOrResize, { passive: true });
      carouselS.addEventListener('scroll', onScrollOrResize, { passive: true });
      // Initial pass after layout settles.
      setTimeout(evaluateReveal, 200);
    }

    // ---- Center on default attachment on load (instant, no visible scroll) ----
    function bootCenter() {
      var len = itemsOf(carouselA).length;
      var idx = Math.max(0, Math.min(len - 1, defaultIdx));
      // Use auto so the initial position doesn't smooth-scroll on page load.
      centerOnIndex(idx, 'auto');
    }
    if (document.readyState === 'complete') {
      // Wait one frame so layout is settled and scroll-snap padding is resolved.
      window.requestAnimationFrame(bootCenter);
    } else {
      window.addEventListener('load', function () {
        window.requestAnimationFrame(bootCenter);
      }, { once: true });
    }
  }

  // ---- Details Drawer (slide-out spec sheet) ----
  // Triggered by any element with [data-cl-details-trigger]. Drawer + overlay are
  // siblings of the section wrapper (rendered at section markup level, position:fixed).
  function bindDetailsDrawer(root) {
    if (root.__clDetailsBound) return;
    root.__clDetailsBound = true;

    var drawerId = root.getAttribute('data-cl-details-drawer-id');
    if (!drawerId) return;
    var drawer = document.querySelector('[data-cl-details-drawer][data-cl-details-drawer-id="' + drawerId + '"]');
    var overlay = document.querySelector('[data-cl-details-drawer-overlay][data-cl-details-drawer-id="' + drawerId + '"]');
    if (!drawer || !overlay) return;

    var lockBody = root.getAttribute('data-cl-details-lock-body') !== 'false';
    var closeOnOverlay = root.getAttribute('data-cl-details-close-overlay') !== 'false';
    var closeOnEscape = root.getAttribute('data-cl-details-close-escape') !== 'false';
    var prevFocus = null;
    var savedScrollY = 0;

    function isOpen() {
      return drawer.classList.contains('is-open');
    }

    function setTriggersExpanded(value) {
      document.querySelectorAll('[data-cl-details-trigger]').forEach(function (t) {
        t.setAttribute('aria-expanded', value ? 'true' : 'false');
      });
    }

    function applyBodyLock() {
      if (!lockBody) return;
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('cl-body-no-scroll');
      // iOS Safari fix: overflow:hidden on body alone does NOT lock scrolling on
      // iOS — touch swipes still scroll the underlying page. The reliable pattern
      // is to fix the body in place and offset by the current scroll position.
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function releaseBodyLock() {
      if (!lockBody) return;
      document.body.classList.remove('cl-body-no-scroll');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      // Restore the exact scroll position the buyer was at before opening
      window.scrollTo(0, savedScrollY);
    }

    function openDrawer(triggerEl) {
      if (isOpen()) return;
      prevFocus = triggerEl || document.activeElement;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      setTriggersExpanded(true);
      applyBodyLock();
      setTimeout(function () {
        var closeBtn = drawer.querySelector('[data-cl-details-drawer-close]');
        if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      }, 80);
    }

    function closeDrawer() {
      if (!isOpen()) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      setTriggersExpanded(false);
      releaseBodyLock();
      if (prevFocus && typeof prevFocus.focus === 'function') {
        try { prevFocus.focus(); } catch (e) { /* element may have been removed */ }
      }
    }

    // Propagate the section's visual-distinction setting to ALL triggers on the
    // page (including PDP-block triggers in a different section), so the
    // setting effectively controls every entry-point into this drawer.
    var distinction = root.getAttribute('data-cl-details-trigger-distinction');
    if (distinction && distinction !== 'none') {
      var distClass = 'cl-details-drawer-trigger--dist-' + distinction;
      document.querySelectorAll('[data-cl-details-trigger]').forEach(function (t) {
        // Strip any prior distinction class so a section-setting change replaces, not stacks
        Array.prototype.slice.call(t.classList).forEach(function (c) {
          if (c.indexOf('cl-details-drawer-trigger--dist-') === 0) t.classList.remove(c);
        });
        t.classList.add(distClass);
      });
    }

    // Hook up triggers across the page (any element with [data-cl-details-trigger])
    document.querySelectorAll('[data-cl-details-trigger]').forEach(function (t) {
      if (t.__clDetailsTriggerBound) return;
      t.__clDetailsTriggerBound = true;
      t.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer(t);
      });
    });

    // Close button
    var closeBtn = drawer.querySelector('[data-cl-details-drawer-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    // Overlay click closes
    if (closeOnOverlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    // Escape closes
    if (closeOnEscape) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) closeDrawer();
      });
    }

    // Focus trap inside drawer
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isOpen()) return;
      var focusable = drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  // ---- Comparison Drawer (Project 3) ----
  // Slide-out drawer for the product comparison guide. Rendered inside the
  // cl-product-pdp-preorder section. Reuses the cl-details-drawer base CSS
  // for panel/overlay styling, but uses its own data-attribute namespace
  // (data-cl-comp-*) so multiple drawer types on one page don't collide.
  function bindComparisonDrawer(root) {
    if (root.__clCompBound) return;
    root.__clCompBound = true;

    var drawerId = root.getAttribute('data-cl-comp-drawer-id');
    if (!drawerId) return;
    var drawer = document.querySelector('[data-cl-comp-drawer][data-cl-comp-drawer-id="' + drawerId + '"]');
    var overlay = document.querySelector('[data-cl-comp-drawer-overlay][data-cl-comp-drawer-id="' + drawerId + '"]');
    if (!drawer || !overlay) return;

    var prevFocus = null;
    var savedScrollY = 0;

    function isOpen() {
      return drawer.classList.contains('is-open');
    }

    function setTriggersExpanded(value) {
      document.querySelectorAll('[data-cl-comp-trigger="' + drawerId + '"]').forEach(function (t) {
        t.setAttribute('aria-expanded', value ? 'true' : 'false');
      });
    }

    function applyBodyLock() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('cl-body-no-scroll');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function releaseBodyLock() {
      document.body.classList.remove('cl-body-no-scroll');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
    }

    function openDrawer(triggerEl) {
      if (isOpen()) return;
      prevFocus = triggerEl || document.activeElement;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      setTriggersExpanded(true);
      applyBodyLock();
      setTimeout(function () {
        var closeBtn = drawer.querySelector('[data-cl-comp-drawer-close]');
        if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      }, 80);
    }

    function closeDrawer() {
      if (!isOpen()) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      setTriggersExpanded(false);
      releaseBodyLock();
      if (prevFocus && typeof prevFocus.focus === 'function') {
        try { prevFocus.focus(); } catch (e) { /* element may have been removed */ }
      }
    }

    // Scoped trigger binding — only triggers targeting THIS drawer's id
    document.querySelectorAll('[data-cl-comp-trigger="' + drawerId + '"]').forEach(function (t) {
      if (t.__clCompTriggerBound) return;
      t.__clCompTriggerBound = true;
      t.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer(t);
      });
    });

    var closeBtn = drawer.querySelector('[data-cl-comp-drawer-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) closeDrawer();
    });

    // Focus trap
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isOpen()) return;
      var focusable = drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  // ---- System Equation: expanded "More Details" modal (Project 2) ----
  // Per-card modal triggered by the More Details button on each system card.
  // Modal markup is rendered at section level (sibling to the carousel) with
  // data-cl-system-expand-modal="{block.id}" matching the trigger's
  // data-cl-system-expand-trigger="{block.id}".
  function bindSystemExpandedView(root) {
    if (root.__clSysExpBound) return;
    root.__clSysExpBound = true;

    var closeOnOverlay = root.getAttribute('data-cl-system-exp-close-overlay') !== 'false';
    var savedScrollY = 0;
    var currentModal = null;
    var currentTrigger = null;

    function isOpen() {
      return currentModal !== null;
    }

    function applyBodyLock() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('cl-eq-exp-no-scroll');
      // iOS Safari fix — same pattern as the details drawer.
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function releaseBodyLock() {
      document.body.classList.remove('cl-eq-exp-no-scroll');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
    }

    function openModal(blockId, triggerEl) {
      if (isOpen()) closeModal();
      var modal = root.querySelector('[data-cl-system-expand-modal="' + blockId + '"]');
      var overlay = root.querySelector('[data-cl-system-expand-overlay="' + blockId + '"]');
      if (!modal || !overlay) return;
      currentModal = modal;
      currentTrigger = triggerEl;
      modal.classList.add('is-open');
      overlay.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
      applyBodyLock();
      // Reset gallery scroll to start
      var gallery = modal.querySelector('[data-cl-system-exp-gallery]');
      if (gallery) gallery.scrollLeft = 0;
      setTimeout(function () {
        var closeBtn = modal.querySelector('[data-cl-system-expand-close]');
        if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      }, 80);
    }

    function closeModal() {
      if (!isOpen()) return;
      var modal = currentModal;
      var trigger = currentTrigger;
      var overlay = root.querySelector('[data-cl-system-expand-overlay="' + modal.getAttribute('data-cl-system-expand-modal') + '"]');
      modal.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      releaseBodyLock();
      currentModal = null;
      currentTrigger = null;
      if (trigger && typeof trigger.focus === 'function') {
        try { trigger.focus(); } catch (e) { /* element gone */ }
      }
    }

    // Wire triggers
    root.querySelectorAll('[data-cl-system-expand-trigger]').forEach(function (t) {
      if (t.__clSysExpTriggerBound) return;
      t.__clSysExpTriggerBound = true;
      t.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();  // prevent carousel tap-to-center from firing
        openModal(t.getAttribute('data-cl-system-expand-trigger'), t);
      });
    });

    // Wire close buttons
    root.querySelectorAll('[data-cl-system-expand-close]').forEach(function (b) {
      if (b.__clSysExpCloseBound) return;
      b.__clSysExpCloseBound = true;
      b.addEventListener('click', closeModal);
    });

    // Overlay-click close
    if (closeOnOverlay) {
      root.querySelectorAll('[data-cl-system-expand-overlay]').forEach(function (o) {
        if (o.__clSysExpOverlayBound) return;
        o.__clSysExpOverlayBound = true;
        o.addEventListener('click', closeModal);
      });
    }

    // Escape closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) closeModal();
    });

    // Focus trap within the open modal
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isOpen()) return;
      var focusable = currentModal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // Add-to-Cart inline (POST /cart/add.js)
    root.querySelectorAll('[data-cl-system-add-to-cart]').forEach(function (btn) {
      if (btn.__clSysAddBound) return;
      btn.__clSysAddBound = true;
      var origLabel = btn.textContent;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-cl-system-add-to-cart');
        if (!variantId) return;
        btn.classList.add('is-adding');
        btn.disabled = true;
        var origLabelLocal = btn.textContent;
        btn.textContent = 'Adding…';
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            btn.classList.remove('is-adding');
            btn.classList.add('is-added');
            btn.textContent = 'Added to cart ✓';
            // Dispatch a global event so theme cart UI can refresh
            document.dispatchEvent(new CustomEvent('cl:cart:added', { detail: { variantId: variantId } }));
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.disabled = false;
              btn.textContent = origLabelLocal;
            }, 2200);
          })
          .catch(function () {
            btn.classList.remove('is-adding');
            btn.classList.add('is-error');
            btn.textContent = 'Couldn\'t add — try again';
            setTimeout(function () {
              btn.classList.remove('is-error');
              btn.disabled = false;
              btn.textContent = origLabelLocal;
            }, 2500);
          });
      });
    });
  }

  // ---- Project 12: Attachment "more info" popup ----
  function bindAttachmentPopup(root) {
    if (root.__clAttPopupBound) return;
    root.__clAttPopupBound = true;

    var savedScrollY = 0;
    var currentPopup = null;
    var currentTrigger = null;

    function isOpen() {
      return currentPopup !== null;
    }

    function applyBodyLock() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('cl-eq-att-no-scroll');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function releaseBodyLock() {
      document.body.classList.remove('cl-eq-att-no-scroll');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
    }

    function openPopup(blockId, triggerEl) {
      if (isOpen()) closePopup();
      var popup = root.querySelector('[data-cl-attachment-popup="' + blockId + '"]');
      if (!popup) return;
      currentPopup = popup;
      currentTrigger = triggerEl;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
      applyBodyLock();
      setTimeout(function () {
        var closeBtn = popup.querySelector('[data-cl-attachment-popup-close]');
        if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      }, 80);
    }

    function closePopup() {
      if (!isOpen()) return;
      var popup = currentPopup;
      var trigger = currentTrigger;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      releaseBodyLock();
      currentPopup = null;
      currentTrigger = null;
      if (trigger && typeof trigger.focus === 'function') {
        try { trigger.focus(); } catch (e) { /* element gone */ }
      }
    }

    // Triggers (the ⓘ icon buttons)
    root.querySelectorAll('[data-cl-attachment-popup-trigger]').forEach(function (t) {
      if (t.__clAttPopupTriggerBound) return;
      t.__clAttPopupTriggerBound = true;
      t.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();  // prevent carousel tap-to-center
        openPopup(t.getAttribute('data-cl-attachment-popup-trigger'), t);
      });
    });

    // Close buttons + backdrop
    root.querySelectorAll('[data-cl-attachment-popup-close]').forEach(function (b) {
      if (b.__clAttPopupCloseBound) return;
      b.__clAttPopupCloseBound = true;
      b.addEventListener('click', closePopup);
    });

    // Escape closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) closePopup();
    });

    // Focus trap within open popup
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isOpen()) return;
      var focusable = currentPopup.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // Add-to-Cart variant: POST /cart/add.js then close popup + redirect to /cart
    root.querySelectorAll('[data-cl-attachment-popup-atc]').forEach(function (btn) {
      if (btn.__clAttPopupAtcBound) return;
      btn.__clAttPopupAtcBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-cl-attachment-popup-atc');
        if (!variantId) return;
        var origLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            closePopup();
            setTimeout(function () { window.location.href = '/cart'; }, 250);
          })
          .catch(function () {
            btn.textContent = "Couldn't add — try again";
            setTimeout(function () {
              btn.textContent = origLabel;
              btn.disabled = false;
            }, 2500);
          });
      });
    });
  }

  // ---- Return-state preservation across /cart navigation ----
  // Saves (URL, scrollY) before navigating to /cart so Continue Shopping can return
  // to the exact section the customer was viewing. State expires after 30 minutes.
  var CL_RETURN_STATE_KEY = 'cl-return-state';
  var CL_RETURN_STATE_TTL_MS = 30 * 60 * 1000;

  function clSaveReturnState(reason) {
    try {
      var payload = {
        url: window.location.pathname + window.location.search + window.location.hash,
        scrollY: window.scrollY || window.pageYOffset || 0,
        savedAt: Date.now(),
        reason: reason || 'unknown'
      };
      sessionStorage.setItem(CL_RETURN_STATE_KEY, JSON.stringify(payload));
    } catch (_e) { /* sessionStorage unavailable — silently no-op */ }
  }

  function clReadReturnState() {
    try {
      var raw = sessionStorage.getItem(CL_RETURN_STATE_KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (!s || !s.savedAt) return null;
      if (Date.now() - s.savedAt > CL_RETURN_STATE_TTL_MS) {
        sessionStorage.removeItem(CL_RETURN_STATE_KEY);
        return null;
      }
      return s;
    } catch (_e) { return null; }
  }

  function clClearReturnState() {
    try { sessionStorage.removeItem(CL_RETURN_STATE_KEY); } catch (_e) {}
  }

  function clRestoreReturnState() {
    var s = clReadReturnState();
    if (!s) return;
    var savedUrl;
    try { savedUrl = new URL(s.url, window.location.origin); }
    catch (_e) { clClearReturnState(); return; }
    // Match on PATHNAME only — ignore search params (campaign UTMs etc.) and hash so
    // the restore fires even if the Continue Shopping link appended #product-pdp or
    // the customer arrived via /pages/0-build-hub?utm_source=…
    var currentPath = window.location.pathname;
    var savedPath = savedUrl.pathname;
    if (currentPath !== savedPath) return;
    clClearReturnState();
    // Visible diagnostic — adds an attribute so we can verify restoration fired via dev tools
    try { document.documentElement.setAttribute('data-cl-return-restored', String(s.scrollY)); } catch (_e) {}
    // Run after layout so scrollTo lands on the right pixel. Two RAFs to defer past any
    // immediate browser-side anchor scrolling triggered by hash on landing.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        try { window.scrollTo(0, s.scrollY); } catch (_e) {}
      });
    });
  }

  // Global capture-phase listener: captures user intent to navigate to /cart OR open the
  // cart drawer. Covers anchors going to /cart (View Cart link in drawer, footer cart link,
  // mobile sticky bar cart icon) AND the header cart icon class (.sf-cart-icon / .cart-icon)
  // which the theme intercepts to open the drawer instead of navigating — so the drawer's
  // own View Cart link still has fresh state by the time the user clicks it.
  if (!window.__clReturnStateBound) {
    window.__clReturnStateBound = true;
    document.addEventListener('click', function (e) {
      try {
        if (!e.target || !e.target.closest) return;
        // 1) Anchor going to /cart — save before navigation fires
        var a = e.target.closest('a[href]');
        if (a) {
          var href = a.getAttribute('href');
          if (href) {
            try {
              var url = new URL(href, window.location.origin);
              if (url.origin === window.location.origin && url.pathname === '/cart') {
                clSaveReturnState('a-to-cart');
                return;
              }
            } catch (_e) {}
          }
        }
        // 2) Any cart-opening trigger (header cart icon, ATC buttons, bundle ATC).
        //    Save state pre-emptively so when the user later clicks View Cart inside
        //    the drawer (which IS an anchor to /cart and would also save), the most
        //    recent state already reflects current scroll position. Belt-and-suspenders.
        var trigger = e.target.closest('.sf-cart-icon, .cart-icon, [data-cl-pdp-add], [data-cl-pdp-sticky-add], [data-cl-pdp-bundle-add], [data-cl-pdp-bundle-modal-add], [data-cl-bundle-add], [data-cl-floating-cart]');
        if (trigger) {
          clSaveReturnState('cart-trigger');
        }
      } catch (_e) {}
    }, true);
  }

  // Expose to other scripts (cart-template.liquid reads this to wire Continue Shopping)
  window.MinimogCL = window.MinimogCL || {};
  window.MinimogCL.readReturnState = clReadReturnState;
  window.MinimogCL.clearReturnState = clClearReturnState;
  window.MinimogCL.saveReturnState = clSaveReturnState;

  // ---- Desktop floating cart button (sections/cl-floating-cart.liquid) ----
  function bindFloatingCart(root) {
    var btn = root && root.matches && root.matches('[data-cl-floating-cart]')
      ? root
      : (root && root.querySelector ? root.querySelector('[data-cl-floating-cart]') : null);
    if (!btn || btn.__clFloatingCartBound) return;
    btn.__clFloatingCartBound = true;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.MinimogTheme && window.MinimogTheme.Cart && window.MinimogTheme.Cart.openCartDrawer) {
        window.MinimogTheme.Cart.openCartDrawer();
      } else {
        window.location.href = '/cart';
      }
    });

    var badge = btn.querySelector('[data-cl-floating-cart-badge]');
    function updateBadge(count) {
      if (!badge) return;
      var n = parseInt(count, 10);
      if (isNaN(n) || n < 0) n = 0;
      badge.textContent = String(n);
      if (n > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    }

    // Subscribe to Minimog cart events when available
    if (window.MinimogEvents && typeof window.MinimogEvents.on === 'function') {
      try {
        window.MinimogEvents.on('ON_OPEN_DRAWER_CART', function (cart) {
          if (cart && typeof cart.item_count === 'number') updateBadge(cart.item_count);
        });
        window.MinimogEvents.on('ON_UPDATE_CART', function (cart) {
          if (cart && typeof cart.item_count === 'number') updateBadge(cart.item_count);
        });
      } catch (_e) {}
    }

    // Defensive: also listen to our internal cart:refresh dispatch — re-fetch the cart JSON
    window.addEventListener('cart:refresh', function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (cart && typeof cart.item_count === 'number') updateBadge(cart.item_count);
        })
        .catch(function () {});
    });

    // Universal mirror: the Minimog theme keeps .sf-cart-count up-to-date after AJAX
    // adds (via its own bind), even when our internal events don't fire. Watch any
    // .sf-cart-count element on the page and mirror its text to our badge. Robust
    // catch-all for any cart change regardless of trigger source.
    if (typeof MutationObserver !== 'undefined') {
      var themeCounters = document.querySelectorAll('.sf-cart-count');
      var mirrorFromCounter = function (el) {
        var match = (el.textContent || '').match(/\d+/);
        if (match) updateBadge(parseInt(match[0], 10));
      };
      themeCounters.forEach(function (counter) {
        // Initial sync (in case theme already updated counter post-load before our bind ran)
        mirrorFromCounter(counter);
        try {
          var obs = new MutationObserver(function () { mirrorFromCounter(counter); });
          obs.observe(counter, { childList: true, characterData: true, subtree: true });
        } catch (_e) {}
      });
    }

    // Page-load + visibility change safety net: re-fetch /cart.js once when the
    // tab regains focus (catches cart updates from other tabs / customer drifting back)
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (cart && typeof cart.item_count === 'number') updateBadge(cart.item_count);
        })
        .catch(function () {});
    });
  }

  // ---- Collection Row (cl-cr — sections/cl-collection-row.liquid) ----
  // Renders one collection-driven product showcase. Desktop hovers a card to
  // fade out the custom cover image and cycle through the product gallery.
  // Mobile horizontal-scrolls a snap row, cycling the centered card automatically.
  // ATC icon adds the default variant and opens the theme cart drawer via the
  // shared cart:open / cart:refresh event bridge.
  function bindCollectionRow(root) {
    if (!root || !root.hasAttribute('data-cl-cr')) return;
    if (root.__clCrBound) return;
    root.__clCrBound = true;

    var grid = root.querySelector('[data-cl-cr-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-cl-cr-card]'));
    if (!cards.length) return;

    var cycleEnabled = root.getAttribute('data-cl-cr-cycle') !== 'false';
    var cycleSpeed = parseInt(root.getAttribute('data-cl-cr-speed') || '900', 10) || 900;
    var activeCycle = null; // { card, intervalId, images, idx }

    function stopCycle() {
      if (!activeCycle) return;
      try { clearInterval(activeCycle.intervalId); } catch (_e) {}
      // restore first image so card looks normal again
      try {
        var mainImg = activeCycle.card.querySelector('[data-cl-cr-main]');
        if (mainImg && activeCycle.images && activeCycle.images.length > 0) {
          mainImg.src = activeCycle.images[0];
        }
      } catch (_e) {}
      activeCycle.card.removeAttribute('data-cl-cr-cycling');
      activeCycle = null;
    }

    function startCycle(card) {
      if (!cycleEnabled || !card) return;
      if (activeCycle && activeCycle.card === card) return;
      stopCycle();
      var mainImg = card.querySelector('[data-cl-cr-main]');
      if (!mainImg) return;
      var raw = mainImg.getAttribute('data-cl-cr-images') || '';
      var images = raw.split('|||').filter(function (u) { return u && u.length > 0; });
      if (images.length <= 1) return; // nothing to cycle
      var idx = 0;
      mainImg.src = images[0];
      card.setAttribute('data-cl-cr-cycling', 'true'); // CSS fades cover out
      var intervalId = setInterval(function () {
        idx = (idx + 1) % images.length;
        try { mainImg.src = images[idx]; } catch (_e) {}
      }, cycleSpeed);
      activeCycle = { card: card, intervalId: intervalId, images: images, idx: idx };
    }

    // Desktop: hover starts/stops cycle (mouse events don't fire on touch devices)
    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () { startCycle(card); });
      card.addEventListener('mouseleave', function () {
        if (activeCycle && activeCycle.card === card) stopCycle();
      });

      // ATC button — add variant 1 + open drawer via the shared event bridge
      var atc = card.querySelector('[data-cl-cr-atc]');
      if (atc) {
        atc.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var variantIdRaw = atc.getAttribute('data-variant-id');
          var variantId = parseInt(variantIdRaw, 10);
          if (!variantId) return;
          atc.setAttribute('aria-busy', 'true');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (r) {
              if (!r.ok) return r.json().then(function (j) { throw new Error(j && j.description || 'Cart error'); });
              return r.json();
            })
            .then(function () {
              atc.removeAttribute('aria-busy');
              // Brief confirmation glyph
              var prev = atc.innerHTML;
              atc.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
              setTimeout(function () { atc.innerHTML = prev; }, 1400);
              // Bridge events the theme drawer listens for (see cart:open handler earlier in this file)
              try {
                window.dispatchEvent(new CustomEvent('cart:refresh'));
                window.dispatchEvent(new CustomEvent('cart:open'));
              } catch (_e) {}
            })
            .catch(function () {
              atc.removeAttribute('aria-busy');
            });
        });
      }
    });

    // Mobile: cycle the card most-centered in the horizontal scroll viewport
    if (cycleEnabled && window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
      var mobileCenteredCard = null;
      function pickCenteredCard() {
        var gridRect = grid.getBoundingClientRect();
        var centerX = gridRect.left + gridRect.width / 2;
        var bestCard = null;
        var bestDist = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var card = cards[i];
          var r = card.getBoundingClientRect();
          // Skip if entirely off-screen of the grid
          if (r.right < gridRect.left || r.left > gridRect.right) continue;
          var cardCenter = r.left + r.width / 2;
          var dist = Math.abs(cardCenter - centerX);
          if (dist < bestDist) {
            bestDist = dist;
            bestCard = card;
          }
        }
        if (bestCard && bestCard !== mobileCenteredCard) {
          mobileCenteredCard = bestCard;
          startCycle(bestCard);
        }
      }
      var scrollTimer = null;
      grid.addEventListener('scroll', function () {
        if (scrollTimer) return;
        scrollTimer = setTimeout(function () {
          scrollTimer = null;
          pickCenteredCard();
        }, 120);
      }, { passive: true });
      // Initial pick after layout settles
      setTimeout(pickCenteredCard, 200);
    }
  }

  // ---- Init ----
  function init() {
    clRestoreReturnState();

    document.querySelectorAll('[data-cl-hero-bundle]').forEach(bindHero);
    document.querySelectorAll('[data-cl-carousel]').forEach(bindCarousel);
    document.querySelectorAll('[data-cl-eq-section]').forEach(bindSystemEquation);
    document.querySelectorAll('[data-cl-hero-addons]').forEach(bindBundleBuilder);
    document.querySelectorAll('[data-cl-hero4]').forEach(bindBuilderPro);
    document.querySelectorAll('[data-cl-hs]').forEach(bindHotspots);
    document.querySelectorAll('[data-cl-gal]').forEach(bindGallery);
    document.querySelectorAll('[data-cl-fc]').forEach(bindFeedCollage);
    document.querySelectorAll('[data-cl-phero]').forEach(bindProductHero);
    document.querySelectorAll('[data-cl-pdp]').forEach(bindProductPdp);
    document.querySelectorAll('[data-cl-pdp-photo-lightbox]').forEach(bindPdpPhotoLightbox);
    document.querySelectorAll('[data-cl-pdp-product]').forEach(bindPdpProductExtras);
    document.querySelectorAll('[data-cl-fab]').forEach(bindFab);
    document.querySelectorAll('[data-cl-quick-add]').forEach(bindQuickAdd);
    document.querySelectorAll('[data-cl-msp-step]').forEach(bindMspStep);
    document.querySelectorAll('[data-cl-faq]').forEach(bindFaq);
    document.querySelectorAll('[data-cl-vid]').forEach(bindVideo);
    document.querySelectorAll('[data-cl-bridge-desc]').forEach(bindBridgeDesc);
    document.querySelectorAll('.cl-bridge').forEach(bindBridgeGlossary);
    document.querySelectorAll('[data-cl-details-drawer-root]').forEach(bindDetailsDrawer);
    document.querySelectorAll('[data-cl-comp-drawer-root]').forEach(bindComparisonDrawer);
    document.querySelectorAll('[data-cl-eq-section]').forEach(bindSystemExpandedView);
    document.querySelectorAll('[data-cl-eq-section]').forEach(bindAttachmentPopup);
    document.querySelectorAll('[data-cl-floating-cart]').forEach(bindFloatingCart);
    document.querySelectorAll('[data-cl-cr]').forEach(bindCollectionRow);
    bindInfoTip(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also re-init for Shopify theme editor section reloads.
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    if (!s) return;
    s.querySelectorAll('[data-cl-hero-bundle]').forEach(bindHero);
    s.querySelectorAll('[data-cl-carousel]').forEach(bindCarousel);
    s.querySelectorAll('[data-cl-eq-section]').forEach(bindSystemEquation);
    if (s.matches && s.matches('[data-cl-eq-section]')) bindSystemEquation(s);
    s.querySelectorAll('[data-cl-hero-addons]').forEach(bindBundleBuilder);
    s.querySelectorAll('[data-cl-hero4]').forEach(bindBuilderPro);
    s.querySelectorAll('[data-cl-hs]').forEach(bindHotspots);
    s.querySelectorAll('[data-cl-gal]').forEach(bindGallery);
    s.querySelectorAll('[data-cl-fc]').forEach(bindFeedCollage);
    s.querySelectorAll('[data-cl-phero]').forEach(bindProductHero);
    s.querySelectorAll('[data-cl-pdp]').forEach(bindProductPdp);
    s.querySelectorAll('[data-cl-pdp-photo-lightbox]').forEach(bindPdpPhotoLightbox);
    s.querySelectorAll('[data-cl-pdp-product]').forEach(bindPdpProductExtras);
    s.querySelectorAll('[data-cl-fab]').forEach(bindFab);
    s.querySelectorAll('[data-cl-quick-add]').forEach(bindQuickAdd);
    s.querySelectorAll('[data-cl-msp-step]').forEach(bindMspStep);
    s.querySelectorAll('[data-cl-faq]').forEach(bindFaq);
    s.querySelectorAll('[data-cl-vid]').forEach(bindVideo);
    s.querySelectorAll('[data-cl-bridge-desc]').forEach(bindBridgeDesc);
    s.querySelectorAll('.cl-bridge').forEach(bindBridgeGlossary);
    s.querySelectorAll('[data-cl-details-drawer-root]').forEach(bindDetailsDrawer);
    if (s.matches && s.matches('[data-cl-details-drawer-root]')) bindDetailsDrawer(s);
    s.querySelectorAll('[data-cl-comp-drawer-root]').forEach(bindComparisonDrawer);
    if (s.matches && s.matches('[data-cl-comp-drawer-root]')) bindComparisonDrawer(s);
    s.querySelectorAll('[data-cl-eq-section]').forEach(bindSystemExpandedView);
    if (s.matches && s.matches('[data-cl-eq-section]')) bindSystemExpandedView(s);
    s.querySelectorAll('[data-cl-eq-section]').forEach(bindAttachmentPopup);
    if (s.matches && s.matches('[data-cl-eq-section]')) bindAttachmentPopup(s);
    s.querySelectorAll('[data-cl-floating-cart]').forEach(bindFloatingCart);
    if (s.matches && s.matches('[data-cl-floating-cart]')) bindFloatingCart(s);
    s.querySelectorAll('[data-cl-cr]').forEach(bindCollectionRow);
    if (s.matches && s.matches('[data-cl-cr]')) bindCollectionRow(s);
    bindInfoTip(s);
  });
})();
